import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  VOID7hggqo3abtya as VOID,
  emptyMapr06gerzljqtm as emptyMap,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  Unit_instance104q5opgivhr8 as Unit_instance,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  Companion_instance3fplhgf4ipvld as Companion_instance,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  _Result___init__impl__xyqfz81wclroc5pw7j2 as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  CancellationException3b36o9qz53rgr as CancellationException,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  equals2au1ep9vhcato as equals,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  isInterface3d6p8outrmvmk as isInterface,
  hashCodeq5arwsb9dgti as hashCode,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  throwKotlinNothingValueException2lxmvl03dor6f as throwKotlinNothingValueException,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  listOf1jh22dvmctj1r as listOf,
  to2cs3ny02qtbcb as to,
  mapOf2zpbbmyqk8xpf as mapOf,
  emptyList1g2z5xcrvp2zy as emptyList,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  Result3t1vadv16kmzk as Result,
  _Result___get_value__impl__bjfvqgo6z1uu11rodr as _Result___get_value__impl__bjfvqg,
  _Result___get_isSuccess__impl__sndoy82z6txcyihce8z as _Result___get_isSuccess__impl__sndoy8,
  Result__exceptionOrNull_impl_p6xea9boty10p2dkn4 as Result__exceptionOrNull_impl_p6xea9,
  getKClass1s3j9wy1cofik as getKClass,
  arrayOf1akklvh2at202 as arrayOf,
  createKType1lgox3mzhchp5 as createKType,
  Unitkvevlwgzwiuc as Unit,
  getValue48kllevslyh6 as getValue,
  Enum3alwj03lh1n41 as Enum,
  toString1pkumu07cwy4m as toString,
  enumEntries20mr21zbe3az4 as enumEntries,
  listOfvhqybd2zx248 as listOf_0,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  split2bvyvnrlcifjv as split,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  Exceptiondt2hlxn7j7vw as Exception,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  numberToLong1a4cndvg6c52s as numberToLong,
  mapOf1xd03cq9cnmy8 as mapOf_0,
  Long2qws0ah9gnpki as Long,
  Exception_init_$Init$32vb8wlewqrmh as Exception_init_$Init$,
  captureStack1fzi4aczwc4hg as captureStack,
  isArray1hxjqtqy632bc as isArray,
  Iterable1y3qizuf89iou as Iterable,
  toString30pk9tzaqopn as toString_0,
  KtMap140uvy3s5zad8 as KtMap,
  isNumberiramasdbon0i as isNumber,
  toLongw1zpgk99d84b as toLong,
  LinkedHashMap_init_$Create$1p3p95clvi93w as LinkedHashMap_init_$Create$,
  Default_getInstance30duak50ylke as Default_getInstance,
  encodeToByteArray1onwao0uakjfh as encodeToByteArray,
  _Char___init__impl__6a9atx281r2pd9o601g as _Char___init__impl__6a9atx,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  trimEndvvzjdhan75g as trimEnd,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_instancebove5hxj27a1 as Companion_instance_0,
  Subsystem_WEBSOCKET_getInstance35tdr2j5vnyqn as Subsystem_WEBSOCKET_getInstance,
  InfrastructureIssue2tvwph0eyadg1 as InfrastructureIssue,
  Impact_HIGH_getInstancexaobkfkrtcpy as Impact_HIGH_getInstance,
  ILogger102gekz4uf4a8 as ILogger,
  Impact_LOW_getInstance175qycs8r6wbm as Impact_LOW_getInstance,
  Impact_MEDIUM_getInstance1z2bb1nzb3ufh as Impact_MEDIUM_getInstance,
} from './Shared7Punches-infrastructure-logging.mjs';
import {
  NetworkReachabilityState2q9jru8wd0cgm as NetworkReachabilityState,
  AppLifecycleState1haxglbr7tfw1 as AppLifecycleState,
  NetworkReachabilityState_CONNECTED_getInstanceklfxsi7jyjzd as NetworkReachabilityState_CONNECTED_getInstance,
  AppLifecycleState_FOREGROUND_getInstance37mlw95p8wl1x as AppLifecycleState_FOREGROUND_getInstance,
  toSevenResult26rf3ex1jyb3l as toSevenResult,
  Companion_instance38at02i5wbrbj as Companion_instance_1,
  UnexpectedApiResponse11rd45rhjxm6r as UnexpectedApiResponse,
  ISessionDataProvidercfh7rhcdvasx as ISessionDataProvider,
  INetworkReachabilityProvider3jgigvmyn5cvt as INetworkReachabilityProvider,
  IAppLifecycleProvider24td8xdm5ip99 as IAppLifecycleProvider,
  Failurenhl40niycb88 as Failure,
  Success12c9v3ji39tsw as Success,
} from './Shared7Punches-common-base.mjs';
import {
  launch1c91vkjzdi9sd as launch,
  FlowCollector26clgpmzihvke as FlowCollector,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  SupervisorJobythnfxkr3jxc as SupervisorJob,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
  Mutex16li1l0asjv17 as Mutex,
  MutableStateFlow34bfoyvwu8czu as MutableStateFlow,
  asStateFlow34rribx643ke5 as asStateFlow,
  MutableSharedFlow3g4w4npzofx4w as MutableSharedFlow,
  asSharedFlow2buz3fbrowsyg as asSharedFlow,
  cancelAndJoinca5q7i6o6enf as cancelAndJoin,
  delay1mo3xq8p6x68f as delay,
  withTimeoutOrNull30gvkflmp8gj3 as withTimeoutOrNull,
  get_isActivehakov5bm97hw as get_isActive,
  CompletableDeferred2lnqvsbvx74d3 as CompletableDeferred,
} from './kotlinx-coroutines-core.mjs';
import {
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  UnknownFieldException_init_$Create$1mnsp66c6fnup as UnknownFieldException_init_$Create$,
  StringSerializer_getInstance1k1oz5j50sfik as StringSerializer_getInstance,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
  serializer1hwzc6m64v1op as serializer,
  KSerializerzf77vz1967fq as KSerializer,
  LIST_getInstance3iji3zetpdcxm as LIST_getInstance,
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
  serializer1i4e9ym37oxmo as serializer_0,
  get_nullable197rfua9r7fsz as get_nullable,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  Companion_getInstance35hsivaslc5e3 as Companion_getInstance,
  ApiVersion_APRIL_2026_getInstance1y3s521mv7m63 as ApiVersion_APRIL_2026_getInstance,
  buildV2Path1ie1ylvss3rsk as buildV2Path,
  mapApiErrorResponse18m737xo6p7hy as mapApiErrorResponse,
  get_sharedJson2ja82jrdlkmvt as get_sharedJson,
  Clientssjxb7gh2u6y as Client,
  INetworkDataProvider2v0ql8qlip169 as INetworkDataProvider,
  httpClient2muhbitsbcjn6 as httpClient,
} from './Shared7Punches-infrastructure-network.mjs';
import {
  HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder,
  url2l6iw5ri21nxb as url,
  headers24pki7ce1busg as headers,
  HttpStatement3zxb33q8lku as HttpStatement,
  Plugin_getInstance208zzihiljqrp as Plugin_getInstance,
  header3kx6g3yb4df1r as header,
  webSocketSession3lfe4s3a73e2a as webSocketSession,
} from './ktor-ktor-client-ktor-client-core.mjs';
import {
  Application_getInstance1d4ly18wdhadx as Application_getInstance,
  contentType1lwcfjsjo0z8g as contentType,
  Companion_getInstancepumzx9q4106p as Companion_getInstance_0,
  HttpHeaders_getInstancekqele34vb34f as HttpHeaders_getInstance,
  URLBuilder1nlnzfhn643pn as URLBuilder,
} from './ktor-ktor-http.mjs';
import {
  JsonElementf07o4p6p57al as JsonElement,
  JsonObjectee06ihoeeiqj as JsonObject,
  JsonArray2urf8ey7u44sd as JsonArray,
  Default_getInstance3bgzrb1w1dmdh as Default_getInstance_0,
  get_jsonArray18sglwhl4pclz as get_jsonArray,
  JsonPrimitive3ttzjh2ft5dnx as JsonPrimitive,
  get_contentOrNull35s97cgi8z9eo as get_contentOrNull,
  JsonNull2liwjj96vm0w2 as JsonNull,
  Jsonsmkyu9xjl7fv as Json,
  JsonObjectBuilder2nl6rv6vdayuk as JsonObjectBuilder,
  JsonPrimitiveolttw629wj53 as JsonPrimitive_0,
  JsonArrayBuilderu8edol6ui3pj as JsonArrayBuilder,
  JsonPrimitive1xkjzc5d7ihuv as JsonPrimitive_1,
  JsonPrimitive2fp8648nd60dn as JsonPrimitive_2,
  JsonNull_getInstance1q6cansbfp6ip as JsonNull_getInstance,
} from './kotlinx-serialization-kotlinx-serialization-json.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from './ktor-ktor-utils.mjs';
import {
  Companion_getInstance1rlvzabi952im as Companion_getInstance_1,
  Kind_Factory_getInstance2ge7vb99ubfwr as Kind_Factory_getInstance,
  BeanDefinitionhif1nxb54kgk as BeanDefinition,
  FactoryInstanceFactory2tq2q9e5id3pz as FactoryInstanceFactory,
  KoinDefinition2pr0kscd0vkk6 as KoinDefinition,
  Kind_Singleton_getInstance2ue26e37jajuw as Kind_Singleton_getInstance,
  SingleInstanceFactoryp594z6t2b69a as SingleInstanceFactory,
  module39wmcymxxg0fj as module_0,
} from './projects-core-koin-core.mjs';
import {
  readText30p9xkeoodw49 as readText,
  Text3e6ukp9joohql as Text,
  send1w8fi67yxo60d as send,
  close3ib01rkluotvx as close,
} from './ktor-ktor-shared-ktor-websockets.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForInterface(IWebSocketConnection, 'IWebSocketConnection', VOID, VOID, VOID, [0]);
initMetadataForInterface(IWebSocketMessenger, 'IWebSocketMessenger', VOID, VOID, VOID, [1]);
initMetadataForLambda(WebSocketService$observeConnectionTriggers$slambda$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(WebSocketService$observeConnectionTriggers$slambda$slambda_1, CoroutineImpl, VOID, [1]);
initMetadataForLambda(WebSocketService$establishClientLocked$slambda$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(WebSocketService$establishClientLocked$slambda$slambda_1, CoroutineImpl, VOID, [1]);
initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0_0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
initMetadataForLambda(WebSocketService$observeConnectionTriggers$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(WebSocketService$observeConnectionTriggers$slambda_1, CoroutineImpl, VOID, [1]);
initMetadataForLambda(WebSocketService$establishClientLocked$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(WebSocketService$establishClientLocked$slambda_1, CoroutineImpl, VOID, [1]);
initMetadataForCoroutine($reconcileCOROUTINE$2, CoroutineImpl);
initMetadataForCoroutine($reconcileLockedCOROUTINE$3, CoroutineImpl);
initMetadataForCoroutine($establishClientLockedCOROUTINE$4, CoroutineImpl);
initMetadataForCoroutine($teardownClientLockedCOROUTINE$5, CoroutineImpl);
initMetadataForCoroutine($teardownCurrentClientCOROUTINE$6, CoroutineImpl);
initMetadataForClass(WebSocketService, 'WebSocketService', VOID, VOID, [IWebSocketConnection, IWebSocketMessenger], [0, 1]);
initMetadataForCompanion(Companion);
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(ApiWebSocketTokenResponse, 'ApiWebSocketTokenResponse', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
initMetadataForCoroutine($getCOROUTINE$8, CoroutineImpl);
initMetadataForInterface(IWebSocketTokenAccessor, 'IWebSocketTokenAccessor', VOID, VOID, VOID, [0]);
initMetadataForClass(WebSocketTokenRepository, 'WebSocketTokenRepository', VOID, VOID, [IWebSocketTokenAccessor], [0]);
initMetadataForInterface(IWebSocketTokenRemoteSource, 'IWebSocketTokenRemoteSource', VOID, VOID, VOID, [0]);
initMetadataForCoroutine($getCOROUTINE$9, CoroutineImpl);
initMetadataForClass(WebSocketTokenRemoteSource, 'WebSocketTokenRemoteSource', VOID, VOID, [IWebSocketTokenRemoteSource], [0]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(Channel, 'Channel', VOID, Enum);
initMetadataForClass(ChannelLifecycleEvent, 'ChannelLifecycleEvent');
initMetadataForClass(JoinSucceeded, 'JoinSucceeded', VOID, ChannelLifecycleEvent);
initMetadataForClass(JoinFailed, 'JoinFailed', VOID, ChannelLifecycleEvent);
initMetadataForClass(Left, 'Left', VOID, ChannelLifecycleEvent);
initMetadataForClass(Closed, 'Closed', VOID, ChannelLifecycleEvent);
initMetadataForClass(Error_0, 'Error', VOID, ChannelLifecycleEvent);
initMetadataForCompanion(Companion_1);
initMetadataForClass(Event, 'Event');
initMetadataForClass(Core, 'Core', VOID, Event);
initMetadataForClass(Unknown, 'Unknown', VOID, Event);
initMetadataForClass(CoreEvent, 'CoreEvent', VOID, Enum);
initMetadataForCompanion(Companion_2);
initMetadataForClass(WebSocketEventHandlingOutput, 'WebSocketEventHandlingOutput');
initMetadataForClass(MessageResult, 'MessageResult');
initMetadataForClass(Success_0, 'Success', VOID, MessageResult);
initMetadataForClass(Channel_0, 'Channel', VOID, MessageResult);
initMetadataForClass(Failure_0, 'Failure', VOID, MessageResult);
initMetadataForClass(MessageError, 'MessageError');
initMetadataForObject(MessageFailed, 'MessageFailed', VOID, MessageError);
initMetadataForClass(MessageIgnored, 'MessageIgnored', VOID, MessageError);
initMetadataForClass(MessageIgnoredReason, 'MessageIgnoredReason', VOID, Enum);
initMetadataForClass(Topic, 'Topic');
initMetadataForClass(Notifications, 'Notifications', VOID, Topic);
initMetadataForClass(Analytics, 'Analytics', VOID, Topic);
initMetadataForClass(Unknown_0, 'Unknown', VOID, Topic);
initMetadataForCompanion(Companion_3);
initMetadataForClass(WebSocketConnectionRequest, 'WebSocketConnectionRequest');
initMetadataForClass(WebSocketToken, 'WebSocketToken');
initMetadataForLambda(WebSocketClient$connect$slambda, CoroutineImpl, VOID, [1]);
initMetadataForLambda(WebSocketClient$attemptReconnection$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCoroutine($connectCOROUTINE$10, CoroutineImpl);
initMetadataForCoroutine($disconnectCOROUTINE$11, CoroutineImpl);
initMetadataForCoroutine($closeSessionAndCleanupCOROUTINE$12, CoroutineImpl);
initMetadataForCoroutine($establishConnectionCOROUTINE$14, CoroutineImpl);
initMetadataForCoroutine($receiveMessagesCOROUTINE$15, CoroutineImpl);
initMetadataForCoroutine($handleSuccessfulMessageCOROUTINE$16, CoroutineImpl);
initMetadataForCoroutine($attemptReconnectionCOROUTINE$17, CoroutineImpl);
initMetadataForCoroutine($joinDefaultChannelsCOROUTINE$18, CoroutineImpl);
initMetadataForClass(WebSocketClient, 'WebSocketClient', VOID, VOID, VOID, [1, 0]);
initMetadataForInterface(IWebSocketClientFactory, 'IWebSocketClientFactory');
initMetadataForClass(WebSocketClientFactory, 'WebSocketClientFactory', VOID, VOID, [IWebSocketClientFactory]);
initMetadataForInterface(IWebSocketEventFactory, 'IWebSocketEventFactory');
initMetadataForInterface(IWebSocketMessageHandler, 'IWebSocketMessageHandler');
initMetadataForCompanion(Companion_4);
initMetadataForLambda(WebSocketChannelHandler$waitForJoinCompletion$slambda, CoroutineImpl, VOID, [1]);
initMetadataForCoroutine($joinCOROUTINE$19, CoroutineImpl);
initMetadataForCoroutine($handleCOROUTINE$20, CoroutineImpl);
initMetadataForCoroutine($waitForJoinCompletionCOROUTINE$21, CoroutineImpl);
initMetadataForClass(WebSocketChannelHandler, 'WebSocketChannelHandler', VOID, VOID, VOID, [2, 1, 0, 3]);
initMetadataForCompanion(Companion_5);
initMetadataForClass(WebSocketChannelHandlerException, 'WebSocketChannelHandlerException', VOID, Exception);
initMetadataForClass(WebSocketEventFactory, 'WebSocketEventFactory', WebSocketEventFactory, VOID, [IWebSocketEventFactory]);
initMetadataForClass(WebSocketMessageHandler, 'WebSocketMessageHandler', VOID, VOID, [IWebSocketMessageHandler]);
initMetadataForClass(WebSocketMessageSender, 'WebSocketMessageSender', VOID, VOID, VOID, [3]);
initMetadataForClass(Event_0, 'Event', VOID, Enum);
initMetadataForCompanion(Companion_6);
initMetadataForClass(PhoenixEvent, 'PhoenixEvent');
initMetadataForObject(Reply, 'Reply', VOID, PhoenixEvent);
initMetadataForObject(Join, 'Join', VOID, PhoenixEvent);
initMetadataForObject(Leave, 'Leave', VOID, PhoenixEvent);
initMetadataForObject(Close, 'Close', VOID, PhoenixEvent);
initMetadataForObject(Error_1, 'Error', VOID, PhoenixEvent);
initMetadataForClass(PhoenixOutboundMessage, 'PhoenixOutboundMessage');
initMetadataForCoroutine($nextRefCOROUTINE$23, CoroutineImpl);
initMetadataForClass(PhoenixRefGenerator, 'PhoenixRefGenerator', PhoenixRefGenerator, VOID, VOID, [0]);
initMetadataForCompanion(Companion_7);
initMetadataForObject($serializer_0, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForCompanion(Companion_8);
initMetadataForClass(Response, 'Response', Response, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
initMetadataForClass(Status, 'Status', VOID, Enum);
initMetadataForCompanion(Companion_9);
initMetadataForObject($serializer_1, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(PhoenixReplyPayload, 'PhoenixReplyPayload', PhoenixReplyPayload, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
initMetadataForInterface(IWebSocketPingTask, 'IWebSocketPingTask');
initMetadataForCompanion(Companion_10);
initMetadataForLambda(WebSocketPingTask$startPinging$slambda, CoroutineImpl, VOID, [1]);
initMetadataForClass(WebSocketPingTask, 'WebSocketPingTask', WebSocketPingTask, VOID, [IWebSocketPingTask]);
initMetadataForInterface(IReconnectionStrategy, 'IReconnectionStrategy');
initMetadataForClass(ExponentialBackoffReconnectionStrategy, 'ExponentialBackoffReconnectionStrategy', ExponentialBackoffReconnectionStrategy, VOID, [IReconnectionStrategy]);
initMetadataForInterface(IWebSocketSessionFactory, 'IWebSocketSessionFactory', VOID, VOID, VOID, [1]);
initMetadataForCoroutine($createCOROUTINE$24, CoroutineImpl);
initMetadataForClass(KtorWebSocketSessionFactory, 'KtorWebSocketSessionFactory', KtorWebSocketSessionFactory, VOID, [IWebSocketSessionFactory], [1]);
initMetadataForClass(KtorWebSocketSession, 'KtorWebSocketSession', VOID, VOID, VOID, [1, 0]);
initMetadataForClass(ChannelJoinState, 'ChannelJoinState');
initMetadataForObject(Idle, 'Idle', VOID, ChannelJoinState);
initMetadataForClass(Joining, 'Joining', VOID, ChannelJoinState);
initMetadataForClass(Joined, 'Joined', VOID, ChannelJoinState);
initMetadataForCoroutine($beginOrAwaitJoinCOROUTINE$27, CoroutineImpl);
initMetadataForCoroutine($waitForJoinCompletionCOROUTINE$28, CoroutineImpl);
initMetadataForCoroutine($markJoinedCOROUTINE$29, CoroutineImpl);
initMetadataForCoroutine($markNotJoinedCOROUTINE$30, CoroutineImpl);
initMetadataForCoroutine($failCOROUTINE$31, CoroutineImpl);
initMetadataForCoroutine($closeChannelCOROUTINE$32, CoroutineImpl);
initMetadataForCoroutine($resetCOROUTINE$33, CoroutineImpl);
initMetadataForClass(ChannelStateStore, 'ChannelStateStore', ChannelStateStore, VOID, VOID, [1, 2, 3]);
initMetadataForClass(JoinAttempt, 'JoinAttempt');
initMetadataForClass(StartNew, 'StartNew', VOID, JoinAttempt);
initMetadataForClass(AwaitExisting, 'AwaitExisting', VOID, JoinAttempt);
initMetadataForCompanion(Companion_11);
initMetadataForClass(ChannelStateStoreException, 'ChannelStateStoreException', VOID, Exception);
initMetadataForInterface(IGetWebSocketConnectionRequestUseCase, 'IGetWebSocketConnectionRequestUseCase', VOID, VOID, VOID, [1]);
initMetadataForCoroutine($executeCOROUTINE$34, CoroutineImpl);
initMetadataForClass(GetWebSocketConnectionRequestUseCase, 'GetWebSocketConnectionRequestUseCase', VOID, VOID, [IGetWebSocketConnectionRequestUseCase], [1]);
initMetadataForCompanion(Companion_12);
initMetadataForClass(GetWebSocketConnectionRequestUseCaseException, 'GetWebSocketConnectionRequestUseCaseException', VOID, Exception);
initMetadataForClass(MessageAction, 'MessageAction');
initMetadataForClass(NotificationReceived, 'NotificationReceived', VOID, MessageAction);
initMetadataForCompanion(Companion_13);
initMetadataForClass(NotificationEvent, 'NotificationEvent', VOID, Enum);
initMetadataForClass(NotificationInfo, 'NotificationInfo');
initMetadataForClass(WebSocketConnectionState, 'WebSocketConnectionState');
initMetadataForObject(Disconnected, 'Disconnected', VOID, WebSocketConnectionState);
initMetadataForObject(Connecting, 'Connecting', VOID, WebSocketConnectionState);
initMetadataForObject(Connected, 'Connected', VOID, WebSocketConnectionState);
initMetadataForClass(Reconnecting, 'Reconnecting', VOID, WebSocketConnectionState);
initMetadataForClass(Failed, 'Failed', VOID, WebSocketConnectionState);
//endregion
function IWebSocketConnection() {
}
function IWebSocketMessenger() {
}
function webSocketBreadcrumb(_this__u8e3s4, message) {
  return _this__u8e3s4.i6e(Companion_instance_0.s6e('\uD83E\uDDE6 WebSocket ' + message));
}
function reportWebSocketIssue(_this__u8e3s4, subject, impact, metadata, throwable) {
  metadata = metadata === VOID ? emptyMap() : metadata;
  throwable = throwable === VOID ? null : throwable;
  return _this__u8e3s4.j6e(new InfrastructureIssue(Subsystem_WEBSOCKET_getInstance(), VOID, impact, subject, metadata, throwable));
}
function WebSocketService$observeConnectionTriggers$slambda$slambda(this$0, resultContinuation) {
  this.ea3_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(WebSocketService$observeConnectionTriggers$slambda$slambda).ia3 = function (it, $completion) {
  var tmp = this.ja3(it, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(WebSocketService$observeConnectionTriggers$slambda$slambda).h9 = function (p1, $completion) {
  return this.ia3(p1 instanceof NetworkReachabilityState ? p1 : THROW_CCE(), $completion);
};
protoOf(WebSocketService$observeConnectionTriggers$slambda$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.o8_1 = 2;
          var tmp_0 = this;
          tmp_0.ha3_1 = Companion_instance;
          this.n8_1 = 1;
          suspendResult = reconcile(this.ea3_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var tmp_1 = this;
          this.ha3_1;
          tmp_1.ga3_1 = _Result___init__impl__xyqfz8(Unit_instance);
          this.o8_1 = 3;
          this.n8_1 = 4;
          continue $sm;
        case 2:
          this.o8_1 = 3;
          var tmp_2 = this.q8_1;
          if (tmp_2 instanceof CancellationException) {
            var e = this.q8_1;
            var tmp_3 = this;
            throw e;
          } else {
            var tmp_4 = this.q8_1;
            if (tmp_4 instanceof Error) {
              var e_0 = this.q8_1;
              var tmp_5 = this;
              tmp_5.ga3_1 = _Result___init__impl__xyqfz8(createFailure(e_0));
              this.n8_1 = 4;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 3:
          throw this.q8_1;
        case 4:
          this.o8_1 = 3;
          return Unit_instance;
      }
    } catch ($p) {
      var e_1 = $p;
      if (this.o8_1 === 3) {
        throw e_1;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_1;
      }
    }
   while (true);
};
protoOf(WebSocketService$observeConnectionTriggers$slambda$slambda).ja3 = function (it, completion) {
  var i = new WebSocketService$observeConnectionTriggers$slambda$slambda(this.ea3_1, completion);
  i.fa3_1 = it;
  return i;
};
function WebSocketService$observeConnectionTriggers$slambda$slambda_0(this$0, resultContinuation) {
  var i = new WebSocketService$observeConnectionTriggers$slambda$slambda(this$0, resultContinuation);
  var l = function (it, $completion) {
    return i.ia3(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function WebSocketService$observeConnectionTriggers$slambda$slambda_1(this$0, resultContinuation) {
  this.sa3_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(WebSocketService$observeConnectionTriggers$slambda$slambda_1).wa3 = function (it, $completion) {
  var tmp = this.xa3(it, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(WebSocketService$observeConnectionTriggers$slambda$slambda_1).h9 = function (p1, $completion) {
  return this.wa3(p1 instanceof AppLifecycleState ? p1 : THROW_CCE(), $completion);
};
protoOf(WebSocketService$observeConnectionTriggers$slambda$slambda_1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.o8_1 = 2;
          var tmp_0 = this;
          tmp_0.va3_1 = Companion_instance;
          this.n8_1 = 1;
          suspendResult = reconcile(this.sa3_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var tmp_1 = this;
          this.va3_1;
          tmp_1.ua3_1 = _Result___init__impl__xyqfz8(Unit_instance);
          this.o8_1 = 3;
          this.n8_1 = 4;
          continue $sm;
        case 2:
          this.o8_1 = 3;
          var tmp_2 = this.q8_1;
          if (tmp_2 instanceof CancellationException) {
            var e = this.q8_1;
            var tmp_3 = this;
            throw e;
          } else {
            var tmp_4 = this.q8_1;
            if (tmp_4 instanceof Error) {
              var e_0 = this.q8_1;
              var tmp_5 = this;
              tmp_5.ua3_1 = _Result___init__impl__xyqfz8(createFailure(e_0));
              this.n8_1 = 4;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 3:
          throw this.q8_1;
        case 4:
          this.o8_1 = 3;
          return Unit_instance;
      }
    } catch ($p) {
      var e_1 = $p;
      if (this.o8_1 === 3) {
        throw e_1;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_1;
      }
    }
   while (true);
};
protoOf(WebSocketService$observeConnectionTriggers$slambda$slambda_1).xa3 = function (it, completion) {
  var i = new WebSocketService$observeConnectionTriggers$slambda$slambda_1(this.sa3_1, completion);
  i.ta3_1 = it;
  return i;
};
function WebSocketService$observeConnectionTriggers$slambda$slambda_2(this$0, resultContinuation) {
  var i = new WebSocketService$observeConnectionTriggers$slambda$slambda_1(this$0, resultContinuation);
  var l = function (it, $completion) {
    return i.wa3(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function WebSocketService$establishClientLocked$slambda$slambda(this$0, resultContinuation) {
  this.ga4_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(WebSocketService$establishClientLocked$slambda$slambda).ia4 = function (it, $completion) {
  var tmp = this.ja4(it, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(WebSocketService$establishClientLocked$slambda$slambda).h9 = function (p1, $completion) {
  return this.ia4(p1 instanceof WebSocketConnectionState ? p1 : THROW_CCE(), $completion);
};
protoOf(WebSocketService$establishClientLocked$slambda$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      if (tmp === 0) {
        this.o8_1 = 1;
        this.ga4_1.ua4_1.s22(this.ha4_1);
        return Unit_instance;
      } else if (tmp === 1) {
        throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      throw e;
    }
   while (true);
};
protoOf(WebSocketService$establishClientLocked$slambda$slambda).ja4 = function (it, completion) {
  var i = new WebSocketService$establishClientLocked$slambda$slambda(this.ga4_1, completion);
  i.ha4_1 = it;
  return i;
};
function WebSocketService$establishClientLocked$slambda$slambda_0(this$0, resultContinuation) {
  var i = new WebSocketService$establishClientLocked$slambda$slambda(this$0, resultContinuation);
  var l = function (it, $completion) {
    return i.ia4(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function WebSocketService$establishClientLocked$slambda$slambda_1(this$0, resultContinuation) {
  this.ga5_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(WebSocketService$establishClientLocked$slambda$slambda_1).ia5 = function (it, $completion) {
  var tmp = this.ja5(it, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(WebSocketService$establishClientLocked$slambda$slambda_1).h9 = function (p1, $completion) {
  return this.ia5(p1 instanceof MessageAction ? p1 : THROW_CCE(), $completion);
};
protoOf(WebSocketService$establishClientLocked$slambda$slambda_1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.ga5_1.wa4_1.b1z(this.ha5_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(WebSocketService$establishClientLocked$slambda$slambda_1).ja5 = function (it, completion) {
  var i = new WebSocketService$establishClientLocked$slambda$slambda_1(this.ga5_1, completion);
  i.ha5_1 = it;
  return i;
};
function WebSocketService$establishClientLocked$slambda$slambda_2(this$0, resultContinuation) {
  var i = new WebSocketService$establishClientLocked$slambda$slambda_1(this$0, resultContinuation);
  var l = function (it, $completion) {
    return i.ia5(it, $completion);
  };
  l.$arity = 1;
  return l;
}
function observeConnectionTriggers($this) {
  launch($this.pa4_1, VOID, VOID, WebSocketService$observeConnectionTriggers$slambda_0($this, null));
  launch($this.pa4_1, VOID, VOID, WebSocketService$observeConnectionTriggers$slambda_2($this, null));
}
function reconcile($this, $completion) {
  var tmp = new $reconcileCOROUTINE$2($this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function reconcileLocked($this, $completion) {
  var tmp = new $reconcileLockedCOROUTINE$3($this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function establishClientLocked($this, $completion) {
  var tmp = new $establishClientLockedCOROUTINE$4($this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function teardownClientLocked($this, $completion) {
  var tmp = new $teardownClientLockedCOROUTINE$5($this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function teardownCurrentClient($this, $completion) {
  var tmp = new $teardownCurrentClientCOROUTINE$6($this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function sam$kotlinx_coroutines_flow_FlowCollector$0(function_0) {
  this.sa7_1 = function_0;
}
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).b1z = function (value, $completion) {
  return this.sa7_1(value, $completion);
};
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).k3 = function () {
  return this.sa7_1;
};
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, FlowCollector) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.k3(), other.k3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).hashCode = function () {
  return hashCode(this.k3());
};
function sam$kotlinx_coroutines_flow_FlowCollector$0_0(function_0) {
  this.ta7_1 = function_0;
}
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).b1z = function (value, $completion) {
  return this.ta7_1(value, $completion);
};
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).k3 = function () {
  return this.ta7_1;
};
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, FlowCollector) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.k3(), other.k3());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0_0).hashCode = function () {
  return hashCode(this.k3());
};
function WebSocketService$observeConnectionTriggers$slambda(this$0, resultContinuation) {
  this.ca8_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(WebSocketService$observeConnectionTriggers$slambda).r3m = function ($this$launch, $completion) {
  var tmp = this.s3m($this$launch, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(WebSocketService$observeConnectionTriggers$slambda).h9 = function (p1, $completion) {
  return this.r3m((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(WebSocketService$observeConnectionTriggers$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          var tmp_0 = this.ca8_1.ma4_1.j37();
          var tmp_1 = WebSocketService$observeConnectionTriggers$slambda$slambda_0(this.ca8_1, null);
          suspendResult = tmp_0.k21(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_1), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          throwKotlinNothingValueException();
          break;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(WebSocketService$observeConnectionTriggers$slambda).s3m = function ($this$launch, completion) {
  var i = new WebSocketService$observeConnectionTriggers$slambda(this.ca8_1, completion);
  i.da8_1 = $this$launch;
  return i;
};
function WebSocketService$observeConnectionTriggers$slambda_0(this$0, resultContinuation) {
  var i = new WebSocketService$observeConnectionTriggers$slambda(this$0, resultContinuation);
  var l = function ($this$launch, $completion) {
    return i.r3m($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function WebSocketService$observeConnectionTriggers$slambda_1(this$0, resultContinuation) {
  this.ma8_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(WebSocketService$observeConnectionTriggers$slambda_1).r3m = function ($this$launch, $completion) {
  var tmp = this.s3m($this$launch, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(WebSocketService$observeConnectionTriggers$slambda_1).h9 = function (p1, $completion) {
  return this.r3m((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(WebSocketService$observeConnectionTriggers$slambda_1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          var tmp_0 = this.ma8_1.na4_1.j37();
          var tmp_1 = WebSocketService$observeConnectionTriggers$slambda$slambda_2(this.ma8_1, null);
          suspendResult = tmp_0.k21(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_1), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          throwKotlinNothingValueException();
          break;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(WebSocketService$observeConnectionTriggers$slambda_1).s3m = function ($this$launch, completion) {
  var i = new WebSocketService$observeConnectionTriggers$slambda_1(this.ma8_1, completion);
  i.na8_1 = $this$launch;
  return i;
};
function WebSocketService$observeConnectionTriggers$slambda_2(this$0, resultContinuation) {
  var i = new WebSocketService$observeConnectionTriggers$slambda_1(this$0, resultContinuation);
  var l = function ($this$launch, $completion) {
    return i.r3m($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function WebSocketService$establishClientLocked$slambda($newClient, this$0, resultContinuation) {
  this.wa8_1 = $newClient;
  this.xa8_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(WebSocketService$establishClientLocked$slambda).r3m = function ($this$launch, $completion) {
  var tmp = this.s3m($this$launch, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(WebSocketService$establishClientLocked$slambda).h9 = function (p1, $completion) {
  return this.r3m((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(WebSocketService$establishClientLocked$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          var tmp_0 = this.wa8_1.za8();
          var tmp_1 = WebSocketService$establishClientLocked$slambda$slambda_0(this.xa8_1, null);
          suspendResult = tmp_0.k21(new sam$kotlinx_coroutines_flow_FlowCollector$0_0(tmp_1), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          throwKotlinNothingValueException();
          break;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(WebSocketService$establishClientLocked$slambda).s3m = function ($this$launch, completion) {
  var i = new WebSocketService$establishClientLocked$slambda(this.wa8_1, this.xa8_1, completion);
  i.ya8_1 = $this$launch;
  return i;
};
function WebSocketService$establishClientLocked$slambda_0($newClient, this$0, resultContinuation) {
  var i = new WebSocketService$establishClientLocked$slambda($newClient, this$0, resultContinuation);
  var l = function ($this$launch, $completion) {
    return i.r3m($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function WebSocketService$establishClientLocked$slambda_1($newClient, this$0, resultContinuation) {
  this.ia9_1 = $newClient;
  this.ja9_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(WebSocketService$establishClientLocked$slambda_1).r3m = function ($this$launch, $completion) {
  var tmp = this.s3m($this$launch, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(WebSocketService$establishClientLocked$slambda_1).h9 = function (p1, $completion) {
  return this.r3m((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(WebSocketService$establishClientLocked$slambda_1).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          var tmp_0 = this.ia9_1.la9();
          var tmp_1 = WebSocketService$establishClientLocked$slambda$slambda_2(this.ja9_1, null);
          suspendResult = tmp_0.k21(new sam$kotlinx_coroutines_flow_FlowCollector$0_0(tmp_1), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          throwKotlinNothingValueException();
          break;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(WebSocketService$establishClientLocked$slambda_1).s3m = function ($this$launch, completion) {
  var i = new WebSocketService$establishClientLocked$slambda_1(this.ia9_1, this.ja9_1, completion);
  i.ka9_1 = $this$launch;
  return i;
};
function WebSocketService$establishClientLocked$slambda_2($newClient, this$0, resultContinuation) {
  var i = new WebSocketService$establishClientLocked$slambda_1($newClient, this$0, resultContinuation);
  var l = function ($this$launch, $completion) {
    return i.r3m($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function $reconcileCOROUTINE$2(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.sa5_1 = _this__u8e3s4;
}
protoOf($reconcileCOROUTINE$2).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 6;
          var tmp_0 = this;
          tmp_0.ta5_1 = this.sa5_1.sa4_1;
          this.ua5_1 = this.ta5_1;
          var tmp_1 = this;
          tmp_1.va5_1 = null;
          this.n8_1 = 1;
          suspendResult = this.ua5_1.y27(this.va5_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.wa5_1 = Unit_instance;
          this.n8_1 = 2;
          continue $sm;
        case 2:
          this.o8_1 = 5;
          this.n8_1 = 3;
          suspendResult = reconcileLocked(this.sa5_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 3:
          this.wa5_1 = Unit_instance;
          this.o8_1 = 6;
          this.n8_1 = 4;
          continue $sm;
        case 4:
          this.wa5_1;
          this.o8_1 = 6;
          this.ua5_1.k27(this.va5_1);
          return Unit_instance;
        case 5:
          this.o8_1 = 6;
          var t = this.q8_1;
          this.ua5_1.k27(this.va5_1);
          throw t;
        case 6:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 6) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $reconcileLockedCOROUTINE$3(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.fa6_1 = _this__u8e3s4;
}
protoOf($reconcileLockedCOROUTINE$3).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          this.ga6_1 = this.fa6_1.ma4_1.j37().t().equals(NetworkReachabilityState_CONNECTED_getInstance());
          this.ha6_1 = this.fa6_1.na4_1.j37().t().equals(AppLifecycleState_FOREGROUND_getInstance());
          this.ia6_1 = (this.fa6_1.ta4_1 && this.ga6_1 && this.ha6_1);
          if (this.ia6_1) {
            this.n8_1 = 2;
            suspendResult = establishClientLocked(this.fa6_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            if (this.fa6_1.ta4_1 && !(this.fa6_1.qa4_1 == null)) {
              webSocketBreadcrumb(this.fa6_1.oa4_1, 'auto-disconnecting (reachable=' + this.ga6_1 + ', foreground=' + this.ha6_1 + ')');
            }
            this.n8_1 = 1;
            suspendResult = teardownClientLocked(this.fa6_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          }

        case 1:
          this.n8_1 = 3;
          continue $sm;
        case 2:
          this.n8_1 = 3;
          continue $sm;
        case 3:
          return Unit_instance;
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $establishClientLockedCOROUTINE$4(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.ra6_1 = _this__u8e3s4;
}
protoOf($establishClientLockedCOROUTINE$4).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 9;
          var tmp0_safe_receiver = this.ra6_1.qa4_1;
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.za8();
          var tmp_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.t();
          if (tmp_0 instanceof Failed) {
            webSocketBreadcrumb(this.ra6_1.oa4_1, 'discarding terminally-failed client before reconnect');
            this.n8_1 = 1;
            suspendResult = teardownCurrentClient(this.ra6_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 2;
            continue $sm;
          }

        case 1:
          this.n8_1 = 2;
          continue $sm;
        case 2:
          if (!(this.ra6_1.qa4_1 == null)) {
            webSocketBreadcrumb(this.ra6_1.oa4_1, 'already connected, skipping connect');
            return Unit_instance;
          }

          this.n8_1 = 3;
          suspendResult = this.ra6_1.la4_1.f2w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 3:
          this.sa6_1 = suspendResult;
          this.ta6_1 = this.sa6_1.d1();
          webSocketBreadcrumb(this.ra6_1.oa4_1, 'connecting');
          this.ua6_1 = this.ra6_1.ka4_1.ma9();
          var tmp_1 = this;
          var tmp_2 = launch(this.ra6_1.pa4_1, VOID, VOID, WebSocketService$establishClientLocked$slambda_0(this.ua6_1, this.ra6_1, null));
          tmp_1.va6_1 = listOf([tmp_2, launch(this.ra6_1.pa4_1, VOID, VOID, WebSocketService$establishClientLocked$slambda_2(this.ua6_1, this.ra6_1, null))]);
          this.o8_1 = 8;
          this.n8_1 = 4;
          suspendResult = this.ua6_1.na9(this.ta6_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 4:
          this.o8_1 = 9;
          this.n8_1 = 5;
          continue $sm;
        case 5:
          this.o8_1 = 9;
          this.wa6_1 = this.ua6_1.za8().t();
          var tmp_3 = this.wa6_1;
          if (tmp_3 instanceof Failed) {
            this.ra6_1.ua4_1.s22(this.wa6_1);
            var _iterator__ex2g4s = this.va6_1.j();
            while (_iterator__ex2g4s.k()) {
              var element = _iterator__ex2g4s.l();
              element.s1f();
            }
            this.n8_1 = 7;
            suspendResult = this.ua6_1.oa9(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 6;
            continue $sm;
          }

        case 6:
          webSocketBreadcrumb(this.ra6_1.oa4_1, 'connected');
          this.ra6_1.qa4_1 = this.ua6_1;
          this.ra6_1.ra4_1 = this.va6_1;
          return Unit_instance;
        case 7:
          reportWebSocketIssue(this.ra6_1.oa4_1, 'Connection failed', Impact_HIGH_getInstance(), mapOf(to('reason', this.wa6_1.pa9_1)));
          return Unit_instance;
        case 8:
          this.o8_1 = 9;
          var tmp_4 = this.q8_1;
          if (tmp_4 instanceof CancellationException) {
            var e = this.q8_1;
            var _iterator__ex2g4s_0 = this.va6_1.j();
            while (_iterator__ex2g4s_0.k()) {
              var element_0 = _iterator__ex2g4s_0.l();
              element_0.s1f();
            }
            throw e;
          } else {
            var tmp_5 = this.q8_1;
            if (tmp_5 instanceof Error) {
              var e_0 = this.q8_1;
              var _iterator__ex2g4s_1 = this.va6_1.j();
              while (_iterator__ex2g4s_1.k()) {
                var element_1 = _iterator__ex2g4s_1.l();
                element_1.s1f();
              }
              reportWebSocketIssue(this.ra6_1.oa4_1, 'Connection attempt threw', Impact_HIGH_getInstance(), VOID, e_0);
              throw e_0;
            } else {
              throw this.q8_1;
            }
          }

        case 9:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_1 = $p;
      if (this.o8_1 === 9) {
        throw e_1;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_1;
      }
    }
   while (true);
};
function $teardownClientLockedCOROUTINE$5(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.fa7_1 = _this__u8e3s4;
}
protoOf($teardownClientLockedCOROUTINE$5).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.ga7_1 = !(this.fa7_1.qa4_1 == null);
          this.n8_1 = 1;
          suspendResult = teardownCurrentClient(this.fa7_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.fa7_1.ua4_1.s22(Disconnected_getInstance());
          if (this.ga7_1) {
            webSocketBreadcrumb(this.fa7_1.oa4_1, 'disconnected');
          }

          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $teardownCurrentClientCOROUTINE$6(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.pa7_1 = _this__u8e3s4;
}
protoOf($teardownCurrentClientCOROUTINE$6).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          var _iterator__ex2g4s = this.pa7_1.ra4_1.j();
          while (_iterator__ex2g4s.k()) {
            var element = _iterator__ex2g4s.l();
            element.s1f();
          }

          this.pa7_1.ra4_1 = emptyList();
          this.qa7_1 = this.pa7_1.qa4_1;
          if (this.qa7_1 == null) {
            this.ra7_1 = null;
            this.n8_1 = 2;
            continue $sm;
          } else {
            this.n8_1 = 1;
            suspendResult = this.qa7_1.oa9(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          }

        case 1:
          var tmp_0 = this;
          tmp_0.ra7_1 = Unit_instance;
          this.n8_1 = 2;
          continue $sm;
        case 2:
          this.pa7_1.qa4_1 = null;
          return Unit_instance;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function WebSocketService(clientFactory, sessionDataProvider, networkReachabilityProvider, appLifecycleProvider, logger, scope) {
  scope = scope === VOID ? CoroutineScope_0(SupervisorJob()) : scope;
  this.ka4_1 = clientFactory;
  this.la4_1 = sessionDataProvider;
  this.ma4_1 = networkReachabilityProvider;
  this.na4_1 = appLifecycleProvider;
  this.oa4_1 = logger;
  this.pa4_1 = scope;
  this.qa4_1 = null;
  this.ra4_1 = emptyList();
  this.sa4_1 = Mutex();
  this.ta4_1 = false;
  this.ua4_1 = MutableStateFlow(Disconnected_getInstance());
  this.va4_1 = asStateFlow(this.ua4_1);
  this.wa4_1 = MutableSharedFlow(VOID, 64);
  this.xa4_1 = asSharedFlow(this.wa4_1);
  observeConnectionTriggers(this);
}
function toDomain(_this__u8e3s4) {
  return new WebSocketToken(_this__u8e3s4.qa9_1);
}
function Companion() {
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
function $serializer() {
  $serializer_instance = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.infrastructure.websocket.data.models.ApiWebSocketTokenResponse', this, 1);
  tmp0_serialDesc.wy('token', false);
  this.ra9_1 = tmp0_serialDesc;
}
protoOf($serializer).sa9 = function (encoder, value) {
  var tmp0_desc = this.ra9_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  tmp1_output.zs(tmp0_desc, 0, value.qa9_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer).yn = function (encoder, value) {
  return this.sa9(encoder, value instanceof ApiWebSocketTokenResponse ? value : THROW_CCE());
};
protoOf($serializer).zn = function (decoder) {
  var tmp0_desc = this.ra9_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.kr(tmp0_desc);
  if (tmp5_input.as()) {
    tmp4_local0 = tmp5_input.ur(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.ur(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.lr(tmp0_desc);
  return ApiWebSocketTokenResponse_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer).xn = function () {
  return this.ra9_1;
};
protoOf($serializer).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [StringSerializer_getInstance()];
};
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance == null)
    new $serializer();
  return $serializer_instance;
}
function ApiWebSocketTokenResponse_init_$Init$(seen0, token, serializationConstructorMarker, $this) {
  if (!(1 === (1 & seen0))) {
    throwMissingFieldException(seen0, 1, $serializer_getInstance().ra9_1);
  }
  $this.qa9_1 = token;
  return $this;
}
function ApiWebSocketTokenResponse_init_$Create$(seen0, token, serializationConstructorMarker) {
  return ApiWebSocketTokenResponse_init_$Init$(seen0, token, serializationConstructorMarker, objectCreate(protoOf(ApiWebSocketTokenResponse)));
}
function ApiWebSocketTokenResponse(token) {
  this.qa9_1 = token;
}
protoOf(ApiWebSocketTokenResponse).toString = function () {
  return 'ApiWebSocketTokenResponse(token=' + this.qa9_1 + ')';
};
protoOf(ApiWebSocketTokenResponse).hashCode = function () {
  return getStringHashCode(this.qa9_1);
};
protoOf(ApiWebSocketTokenResponse).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ApiWebSocketTokenResponse))
    return false;
  var tmp0_other_with_cast = other instanceof ApiWebSocketTokenResponse ? other : THROW_CCE();
  if (!(this.qa9_1 === tmp0_other_with_cast.qa9_1))
    return false;
  return true;
};
function $getCOROUTINE$8(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.baa_1 = _this__u8e3s4;
}
protoOf($getCOROUTINE$8).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = this.baa_1.caa_1.daa(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          this.n8_1 = 2;
          continue $sm;
        case 1:
          var unboxed = suspendResult.ul_1;
          suspendResult = new Result(unboxed);
          this.n8_1 = 2;
          continue $sm;
        case 2:
          var this_0 = suspendResult.ul_1;
          var tmp_0;
          if (_Result___get_isSuccess__impl__sndoy8(this_0)) {
            var tmp_1 = _Result___get_value__impl__bjfvqg(this_0);
            var it = (tmp_1 == null ? true : !(tmp_1 == null)) ? tmp_1 : THROW_CCE();
            var value = toDomain(it);
            tmp_0 = _Result___init__impl__xyqfz8(value);
          } else {
            tmp_0 = _Result___init__impl__xyqfz8(_Result___get_value__impl__bjfvqg(this_0));
          }

          var ARGUMENT = tmp_0;
          return toSevenResult(ARGUMENT);
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function WebSocketTokenRepository(remoteSource) {
  this.caa_1 = remoteSource;
}
protoOf(WebSocketTokenRepository).eaa = function ($completion) {
  var tmp = new $getCOROUTINE$8(this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
function IWebSocketTokenRemoteSource() {
}
function WebSocketTokenRemoteSource$get$lambda($apiVersion) {
  return function ($this$headers) {
    Companion_getInstance().x6l($this$headers, $apiVersion);
    return Unit_instance;
  };
}
function WebSocketTokenRemoteSource$get$lambda_0($userId) {
  return function ($this$url, it) {
    $this$url.o44_1.r3q('user_id', $userId.toString());
    return Unit_instance;
  };
}
function $getCOROUTINE$9(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.naa_1 = _this__u8e3s4;
}
protoOf($getCOROUTINE$9).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 13;
          this.n8_1 = 1;
          suspendResult = this.naa_1.hac_1.f2w(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.oaa_1 = suspendResult;
          var tmp_0 = this;
          tmp_0.paa_1 = this.naa_1.gac_1;
          var tmp_1 = this;
          tmp_1.qaa_1 = 'ws/token';
          var tmp_2 = this;
          tmp_2.raa_1 = ApiVersion_APRIL_2026_getInstance();
          this.saa_1 = this.paa_1;
          this.taa_1 = this.qaa_1;
          this.uaa_1 = this.raa_1;
          this.o8_1 = 3;
          var tmp_3 = this;
          tmp_3.waa_1 = Companion_instance;
          var tmp_4 = this;
          tmp_4.xaa_1 = this.saa_1.f6l_1;
          var tmp_5 = this;
          tmp_5.yaa_1 = buildV2Path(this.saa_1, this.taa_1);
          this.zaa_1 = this.xaa_1;
          this.aab_1 = this.yaa_1;
          var tmp_6 = this;
          tmp_6.bab_1 = this.zaa_1;
          this.cab_1 = this.bab_1;
          var tmp_7 = this;
          tmp_7.dab_1 = this.cab_1;
          var tmp_8 = this;
          var this_0 = new HttpRequestBuilder();
          url(this_0, this.aab_1);
          contentType(this_0, Application_getInstance().c3v_1);
          headers(this_0, WebSocketTokenRemoteSource$get$lambda(this.uaa_1));
          this_0.z5n(WebSocketTokenRemoteSource$get$lambda_0(this.oaa_1));
          tmp_8.eab_1 = this_0;
          this.fab_1 = this.dab_1;
          this.gab_1 = this.eab_1;
          this.gab_1.q4r_1 = Companion_getInstance_0().g41_1;
          var tmp_9 = this;
          tmp_9.hab_1 = this.fab_1;
          var tmp_10 = this;
          tmp_10.iab_1 = this.gab_1;
          this.jab_1 = this.hab_1;
          this.kab_1 = this.iab_1;
          this.n8_1 = 2;
          suspendResult = (new HttpStatement(this.kab_1, this.jab_1)).e5t(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.lab_1 = suspendResult;
          var tmp_11 = this;
          this.waa_1;
          var value = this.lab_1;
          tmp_11.vaa_1 = _Result___init__impl__xyqfz8(value);
          this.o8_1 = 13;
          this.n8_1 = 4;
          continue $sm;
        case 3:
          this.o8_1 = 13;
          var tmp_12 = this.q8_1;
          if (tmp_12 instanceof CancellationException) {
            this.mab_1 = this.q8_1;
            var tmp_13 = this;
            throw this.mab_1;
          } else {
            var tmp_14 = this.q8_1;
            if (tmp_14 instanceof Error) {
              this.nab_1 = this.q8_1;
              var tmp_15 = this;
              var exception = this.nab_1;
              tmp_15.vaa_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.n8_1 = 4;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 4:
          this.o8_1 = 13;
          this.oab_1 = this.vaa_1;
          this.pab_1 = this.oab_1;
          this.qab_1 = Result__exceptionOrNull_impl_p6xea9(this.pab_1);
          if (this.qab_1 == null) {
            var tmp_16 = this;
            var tmp_17 = _Result___get_value__impl__bjfvqg(this.pab_1);
            tmp_16.sab_1 = (tmp_17 == null ? true : !(tmp_17 == null)) ? tmp_17 : THROW_CCE();
            this.tab_1 = this.sab_1;
            var tmp_18 = this;
            tmp_18.uab_1 = this.tab_1;
            this.vab_1 = this.uab_1;
            this.wab_1 = this.vab_1.c4u().z43_1;
            var containsArg = this.wab_1;
            if (200 <= containsArg ? containsArg <= 299 : false) {
              this.o8_1 = 9;
              var tmp_19 = this;
              tmp_19.zab_1 = Companion_instance;
              if (getKClass(ApiWebSocketTokenResponse).equals(getKClass(Unit))) {
                var tmp_20 = this;
                tmp_20.bac_1 = this.vab_1;
                this.cac_1 = this.bac_1;
                this.n8_1 = 7;
                var tmp_21 = this.cac_1.y4u();
                var tmp_22 = getKClass(ApiWebSocketTokenResponse);
                var tmp_23;
                try {
                  tmp_23 = createKType(getKClass(ApiWebSocketTokenResponse), arrayOf([]), false);
                } catch ($p) {
                  var tmp_24;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3 = $p;
                    tmp_24 = null;
                  } else {
                    throw $p;
                  }
                  tmp_23 = tmp_24;
                }
                suspendResult = tmp_21.a4u(new TypeInfo(tmp_22, tmp_23), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_25 = this;
                tmp_25.dac_1 = this.vab_1;
                this.eac_1 = this.dac_1;
                this.n8_1 = 6;
                var tmp_26 = this.eac_1.y4u();
                var tmp_27 = getKClass(JsonElement);
                var tmp_28;
                try {
                  tmp_28 = createKType(getKClass(JsonElement), arrayOf([]), false);
                } catch ($p) {
                  var tmp_29;
                  if ($p instanceof Error) {
                    var _unused_var__etf5q3_0 = $p;
                    tmp_29 = null;
                  } else {
                    throw $p;
                  }
                  tmp_28 = tmp_29;
                }
                suspendResult = tmp_26.a4u(new TypeInfo(tmp_27, tmp_28), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              var tmp_30 = this;
              tmp_30.fac_1 = Companion_instance;
              this.n8_1 = 5;
              suspendResult = mapApiErrorResponse(this.vab_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }
          } else {
            var tmp_31 = this;
            var it = this.qab_1;
            var exception_0 = Companion_instance_1.b2u(it);
            tmp_31.rab_1 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_0)));
            this.n8_1 = 12;
            continue $sm;
          }

        case 5:
          var tmp4 = suspendResult;
          var tmp_32 = this;
          this.fac_1;
          tmp_32.xab_1 = _Result___init__impl__xyqfz8(createFailure(tmp4));
          this.n8_1 = 11;
          continue $sm;
        case 6:
          var tmp2 = suspendResult instanceof JsonElement ? suspendResult : THROW_CCE();
          var tmp_33 = this;
          var tmp$ret$0;
          l$ret$1: do {
            var json = get_sharedJson();
            var this_1 = serializer(createKType(getKClass(ApiWebSocketTokenResponse), arrayOf([]), false));
            var serializer_0 = isInterface(this_1, KSerializer) ? this_1 : THROW_CCE();
            var tmp_34;
            if (tmp2 instanceof JsonObject) {
              tmp_34 = tmp2.c3p('data');
            } else {
              tmp_34 = false;
            }
            if (tmp_34) {
              var dataValue = getValue(tmp2, 'data');
              var tmp_35;
              if (dataValue instanceof JsonObject) {
                tmp_35 = true;
              } else {
                if (dataValue instanceof JsonArray) {
                  tmp_35 = equals(serializer_0.xn().op(), LIST_getInstance());
                } else {
                  tmp_35 = false;
                }
              }
              var shouldAttemptUnwrap = tmp_35;
              if (shouldAttemptUnwrap) {
                try {
                  tmp$ret$0 = json.s5z(serializer_0, dataValue);
                  break l$ret$1;
                } catch ($p) {
                  if ($p instanceof SerializationException) {
                    var e = $p;
                  } else {
                    throw $p;
                  }
                }
              }
            }
            tmp$ret$0 = json.s5z(serializer_0, tmp2);
          }
           while (false);
          tmp_33.aac_1 = tmp$ret$0;
          this.n8_1 = 8;
          continue $sm;
        case 7:
          var tmp_36 = this;
          tmp_36.aac_1 = suspendResult instanceof ApiWebSocketTokenResponse ? suspendResult : THROW_CCE();
          this.n8_1 = 8;
          continue $sm;
        case 8:
          var tmp1 = this.aac_1;
          var tmp_37 = this;
          this.zab_1;
          tmp_37.yab_1 = _Result___init__impl__xyqfz8(tmp1);
          this.o8_1 = 13;
          this.n8_1 = 10;
          continue $sm;
        case 9:
          this.o8_1 = 13;
          var tmp_38 = this.q8_1;
          if (tmp_38 instanceof CancellationException) {
            var e_0 = this.q8_1;
            var tmp_39 = this;
            throw e_0;
          } else {
            var tmp_40 = this.q8_1;
            if (tmp_40 instanceof Error) {
              var e_1 = this.q8_1;
              var tmp_41 = this;
              tmp_41.yab_1 = _Result___init__impl__xyqfz8(createFailure(e_1));
              this.n8_1 = 10;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 10:
          this.o8_1 = 13;
          var tmp_42 = this;
          var this_2 = this.yab_1;
          var exception_1 = Result__exceptionOrNull_impl_p6xea9(this_2);
          var tmp_43;
          if (exception_1 == null) {
            var tmp_44 = _Result___get_value__impl__bjfvqg(this_2);
            var value_0 = (tmp_44 == null ? true : !(tmp_44 == null)) ? tmp_44 : THROW_CCE();
            tmp_43 = new Result(_Result___init__impl__xyqfz8(value_0));
          } else {
            var exception_2 = new UnexpectedApiResponse(exception_1);
            tmp_43 = new Result(_Result___init__impl__xyqfz8(createFailure(exception_2)));
          }

          tmp_42.xab_1 = tmp_43.ul_1;
          this.n8_1 = 11;
          continue $sm;
        case 11:
          this.rab_1 = new Result(this.xab_1);
          this.n8_1 = 12;
          continue $sm;
        case 12:
          return this.rab_1;
        case 13:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_2 = $p;
      if (this.o8_1 === 13) {
        throw e_2;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_2;
      }
    }
   while (true);
};
function WebSocketTokenRemoteSource(apiClient, sessionDataProvider) {
  this.gac_1 = apiClient;
  this.hac_1 = sessionDataProvider;
}
protoOf(WebSocketTokenRemoteSource).daa = function ($completion) {
  var tmp = new $getCOROUTINE$9(this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  var tmp_0 = tmp.v8();
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    return tmp_0;
  return tmp_0;
};
function get_webSocketModule() {
  _init_properties_WebSocketModule_kt__44ylq7();
  return webSocketModule;
}
var webSocketModule;
function webSocketModule$lambda($this$module) {
  _init_properties_WebSocketModule_kt__44ylq7();
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2 = webSocketModule$lambda$lambda;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Factory_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(IWebSocketTokenRemoteSource), null, tmp2, kind, secondaryTypes);
  var factory = new FactoryInstanceFactory(def);
  $this$module.p1c(factory);
  new KoinDefinition($this$module, factory);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition = webSocketModule$lambda$lambda_0;
  var scopeQualifier_0 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_0 = Kind_Singleton_getInstance();
  var secondaryTypes_0 = emptyList();
  var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(IWebSocketTokenAccessor), null, definition, kind_0, secondaryTypes_0);
  var factory_0 = new SingleInstanceFactory(def_0);
  $this$module.p1c(factory_0);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_0);
  }
  new KoinDefinition($this$module, factory_0);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_0 = webSocketModule$lambda$lambda_1;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_1 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_1 = Kind_Factory_getInstance();
  var secondaryTypes_1 = emptyList();
  var def_1 = new BeanDefinition(scopeQualifier_1, getKClass(IGetWebSocketConnectionRequestUseCase), null, tmp2_0, kind_1, secondaryTypes_1);
  var factory_1 = new FactoryInstanceFactory(def_1);
  $this$module.p1c(factory_1);
  new KoinDefinition($this$module, factory_1);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_0 = webSocketModule$lambda$lambda_2;
  var scopeQualifier_2 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_2 = Kind_Singleton_getInstance();
  var secondaryTypes_2 = emptyList();
  var def_2 = new BeanDefinition(scopeQualifier_2, getKClass(IWebSocketSessionFactory), null, definition_0, kind_2, secondaryTypes_2);
  var factory_2 = new SingleInstanceFactory(def_2);
  $this$module.p1c(factory_2);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_2);
  }
  new KoinDefinition($this$module, factory_2);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_1 = webSocketModule$lambda$lambda_3;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_3 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_3 = Kind_Factory_getInstance();
  var secondaryTypes_3 = emptyList();
  var def_3 = new BeanDefinition(scopeQualifier_3, getKClass(PhoenixRefGenerator), null, tmp2_1, kind_3, secondaryTypes_3);
  var factory_3 = new FactoryInstanceFactory(def_3);
  $this$module.p1c(factory_3);
  new KoinDefinition($this$module, factory_3);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_2 = webSocketModule$lambda$lambda_4;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_4 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_4 = Kind_Factory_getInstance();
  var secondaryTypes_4 = emptyList();
  var def_4 = new BeanDefinition(scopeQualifier_4, getKClass(IWebSocketEventFactory), null, tmp2_2, kind_4, secondaryTypes_4);
  var factory_4 = new FactoryInstanceFactory(def_4);
  $this$module.p1c(factory_4);
  new KoinDefinition($this$module, factory_4);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_3 = webSocketModule$lambda$lambda_5;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_5 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_5 = Kind_Factory_getInstance();
  var secondaryTypes_5 = emptyList();
  var def_5 = new BeanDefinition(scopeQualifier_5, getKClass(IWebSocketMessageHandler), null, tmp2_3, kind_5, secondaryTypes_5);
  var factory_5 = new FactoryInstanceFactory(def_5);
  $this$module.p1c(factory_5);
  new KoinDefinition($this$module, factory_5);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_4 = webSocketModule$lambda$lambda_6;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_6 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_6 = Kind_Factory_getInstance();
  var secondaryTypes_6 = emptyList();
  var def_6 = new BeanDefinition(scopeQualifier_6, getKClass(IWebSocketPingTask), null, tmp2_4, kind_6, secondaryTypes_6);
  var factory_6 = new FactoryInstanceFactory(def_6);
  $this$module.p1c(factory_6);
  new KoinDefinition($this$module, factory_6);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_5 = webSocketModule$lambda$lambda_7;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_7 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_7 = Kind_Factory_getInstance();
  var secondaryTypes_7 = emptyList();
  var def_7 = new BeanDefinition(scopeQualifier_7, getKClass(IReconnectionStrategy), null, tmp2_5, kind_7, secondaryTypes_7);
  var factory_7 = new FactoryInstanceFactory(def_7);
  $this$module.p1c(factory_7);
  new KoinDefinition($this$module, factory_7);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_6 = webSocketModule$lambda$lambda_8;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_8 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_8 = Kind_Factory_getInstance();
  var secondaryTypes_8 = emptyList();
  var def_8 = new BeanDefinition(scopeQualifier_8, getKClass(IWebSocketClientFactory), null, tmp2_6, kind_8, secondaryTypes_8);
  var factory_8 = new FactoryInstanceFactory(def_8);
  $this$module.p1c(factory_8);
  new KoinDefinition($this$module, factory_8);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_1 = webSocketModule$lambda$lambda_9;
  var scopeQualifier_9 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_9 = Kind_Singleton_getInstance();
  var secondaryTypes_9 = emptyList();
  var def_9 = new BeanDefinition(scopeQualifier_9, getKClass(WebSocketService), null, definition_1, kind_9, secondaryTypes_9);
  var factory_9 = new SingleInstanceFactory(def_9);
  $this$module.p1c(factory_9);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_9);
  }
  new KoinDefinition($this$module, factory_9);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_2 = webSocketModule$lambda$lambda_10;
  var scopeQualifier_10 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_10 = Kind_Singleton_getInstance();
  var secondaryTypes_10 = emptyList();
  var def_10 = new BeanDefinition(scopeQualifier_10, getKClass(IWebSocketConnection), null, definition_2, kind_10, secondaryTypes_10);
  var factory_10 = new SingleInstanceFactory(def_10);
  $this$module.p1c(factory_10);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_10);
  }
  new KoinDefinition($this$module, factory_10);
  // Inline function 'org.koin.core.module.Module.single' call
  // Inline function 'org.koin.core.module._singleInstanceFactory' call
  var definition_3 = webSocketModule$lambda$lambda_11;
  var scopeQualifier_11 = Companion_getInstance_1().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_11 = Kind_Singleton_getInstance();
  var secondaryTypes_11 = emptyList();
  var def_11 = new BeanDefinition(scopeQualifier_11, getKClass(IWebSocketMessenger), null, definition_3, kind_11, secondaryTypes_11);
  var factory_11 = new SingleInstanceFactory(def_11);
  $this$module.p1c(factory_11);
  if (false || $this$module.i1c_1) {
    $this$module.r1c(factory_11);
  }
  new KoinDefinition($this$module, factory_11);
  return Unit_instance;
}
function webSocketModule$lambda$lambda($this$factory, it) {
  _init_properties_WebSocketModule_kt__44ylq7();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(Client), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  return new WebSocketTokenRemoteSource(tmp, tmp$ret$1);
}
function webSocketModule$lambda$lambda_0($this$single, it) {
  _init_properties_WebSocketModule_kt__44ylq7();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$single.q1d(getKClass(IWebSocketTokenRemoteSource), null, null);
  return new WebSocketTokenRepository(tmp$ret$0);
}
function webSocketModule$lambda$lambda_1($this$factory, it) {
  _init_properties_WebSocketModule_kt__44ylq7();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(IWebSocketTokenAccessor), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(INetworkDataProvider), null, null);
  return new GetWebSocketConnectionRequestUseCase(tmp, tmp$ret$1.y6l());
}
function webSocketModule$lambda$lambda_2($this$single, it) {
  _init_properties_WebSocketModule_kt__44ylq7();
  return new KtorWebSocketSessionFactory();
}
function webSocketModule$lambda$lambda_3($this$factory, it) {
  _init_properties_WebSocketModule_kt__44ylq7();
  return new PhoenixRefGenerator();
}
function webSocketModule$lambda$lambda_4($this$factory, it) {
  _init_properties_WebSocketModule_kt__44ylq7();
  return new WebSocketEventFactory();
}
function webSocketModule$lambda$lambda_5($this$factory, it) {
  _init_properties_WebSocketModule_kt__44ylq7();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(IWebSocketEventFactory), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(ILogger), null, null);
  return new WebSocketMessageHandler(tmp, tmp$ret$1);
}
function webSocketModule$lambda$lambda_6($this$factory, it) {
  _init_properties_WebSocketModule_kt__44ylq7();
  return new WebSocketPingTask();
}
function webSocketModule$lambda$lambda_7($this$factory, it) {
  _init_properties_WebSocketModule_kt__44ylq7();
  return new ExponentialBackoffReconnectionStrategy();
}
function webSocketModule$lambda$lambda_8($this$factory, it) {
  _init_properties_WebSocketModule_kt__44ylq7();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(IGetWebSocketConnectionRequestUseCase), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_0 = $this$factory.q1d(getKClass(IWebSocketSessionFactory), null, null);
  var tmp_1 = webSocketModule$lambda$lambda$lambda($this$factory);
  var tmp_2 = webSocketModule$lambda$lambda$lambda_0($this$factory);
  var tmp_3 = webSocketModule$lambda$lambda$lambda_1($this$factory);
  var tmp_4 = webSocketModule$lambda$lambda$lambda_2($this$factory);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$2 = $this$factory.q1d(getKClass(ILogger), null, null);
  return new WebSocketClientFactory(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp$ret$2);
}
function webSocketModule$lambda$lambda$lambda($this_factory) {
  return function () {
    // Inline function 'org.koin.core.scope.Scope.get' call
    return $this_factory.q1d(getKClass(PhoenixRefGenerator), null, null);
  };
}
function webSocketModule$lambda$lambda$lambda_0($this_factory) {
  return function () {
    // Inline function 'org.koin.core.scope.Scope.get' call
    return $this_factory.q1d(getKClass(IWebSocketMessageHandler), null, null);
  };
}
function webSocketModule$lambda$lambda$lambda_1($this_factory) {
  return function () {
    // Inline function 'org.koin.core.scope.Scope.get' call
    return $this_factory.q1d(getKClass(IWebSocketPingTask), null, null);
  };
}
function webSocketModule$lambda$lambda$lambda_2($this_factory) {
  return function () {
    // Inline function 'org.koin.core.scope.Scope.get' call
    return $this_factory.q1d(getKClass(IReconnectionStrategy), null, null);
  };
}
function webSocketModule$lambda$lambda_9($this$single, it) {
  _init_properties_WebSocketModule_kt__44ylq7();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$single.q1d(getKClass(IWebSocketClientFactory), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_0 = $this$single.q1d(getKClass(ISessionDataProvider), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_1 = $this$single.q1d(getKClass(INetworkReachabilityProvider), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_2 = $this$single.q1d(getKClass(IAppLifecycleProvider), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$4 = $this$single.q1d(getKClass(ILogger), null, null);
  return new WebSocketService(tmp, tmp_0, tmp_1, tmp_2, tmp$ret$4);
}
function webSocketModule$lambda$lambda_10($this$single, it) {
  _init_properties_WebSocketModule_kt__44ylq7();
  // Inline function 'org.koin.core.scope.Scope.get' call
  return $this$single.q1d(getKClass(WebSocketService), null, null);
}
function webSocketModule$lambda$lambda_11($this$single, it) {
  _init_properties_WebSocketModule_kt__44ylq7();
  // Inline function 'org.koin.core.scope.Scope.get' call
  return $this$single.q1d(getKClass(WebSocketService), null, null);
}
var properties_initialized_WebSocketModule_kt_pb333x;
function _init_properties_WebSocketModule_kt__44ylq7() {
  if (!properties_initialized_WebSocketModule_kt_pb333x) {
    properties_initialized_WebSocketModule_kt_pb333x = true;
    webSocketModule = module_0(VOID, webSocketModule$lambda);
  }
}
function IWebSocketTokenAccessor() {
}
var Channel_NOTIFICATIONS_instance;
var Channel_ANALYTICS_instance;
var Channel_UNKNOWN_instance;
function Companion_0() {
}
var Companion_instance_3;
function Companion_getInstance_3() {
  return Companion_instance_3;
}
var Channel_entriesInitialized;
function Channel_initEntries() {
  if (Channel_entriesInitialized)
    return Unit_instance;
  Channel_entriesInitialized = true;
  Channel_NOTIFICATIONS_instance = new Channel('NOTIFICATIONS', 0, 'notifications');
  Channel_ANALYTICS_instance = new Channel('ANALYTICS', 1, 'analytics');
  Channel_UNKNOWN_instance = new Channel('UNKNOWN', 2, 'unknown');
}
function Channel(name, ordinal, value) {
  Enum.call(this, name, ordinal);
  this.kac_1 = value;
}
function Channel_NOTIFICATIONS_getInstance() {
  Channel_initEntries();
  return Channel_NOTIFICATIONS_instance;
}
function Channel_ANALYTICS_getInstance() {
  Channel_initEntries();
  return Channel_ANALYTICS_instance;
}
function Channel_UNKNOWN_getInstance() {
  Channel_initEntries();
  return Channel_UNKNOWN_instance;
}
function JoinSucceeded(topic, joinRef) {
  ChannelLifecycleEvent.call(this);
  this.lac_1 = topic;
  this.mac_1 = joinRef;
}
protoOf(JoinSucceeded).toString = function () {
  return 'JoinSucceeded(topic=' + toString(this.lac_1) + ', joinRef=' + this.mac_1 + ')';
};
protoOf(JoinSucceeded).hashCode = function () {
  var result = hashCode(this.lac_1);
  result = imul(result, 31) + getStringHashCode(this.mac_1) | 0;
  return result;
};
protoOf(JoinSucceeded).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof JoinSucceeded))
    return false;
  var tmp0_other_with_cast = other instanceof JoinSucceeded ? other : THROW_CCE();
  if (!equals(this.lac_1, tmp0_other_with_cast.lac_1))
    return false;
  if (!(this.mac_1 === tmp0_other_with_cast.mac_1))
    return false;
  return true;
};
function JoinFailed(topic, joinRef, reason) {
  ChannelLifecycleEvent.call(this);
  this.nac_1 = topic;
  this.oac_1 = joinRef;
  this.pac_1 = reason;
}
protoOf(JoinFailed).toString = function () {
  return 'JoinFailed(topic=' + toString(this.nac_1) + ', joinRef=' + this.oac_1 + ', reason=' + this.pac_1 + ')';
};
protoOf(JoinFailed).hashCode = function () {
  var result = hashCode(this.nac_1);
  result = imul(result, 31) + getStringHashCode(this.oac_1) | 0;
  result = imul(result, 31) + (this.pac_1 == null ? 0 : getStringHashCode(this.pac_1)) | 0;
  return result;
};
protoOf(JoinFailed).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof JoinFailed))
    return false;
  var tmp0_other_with_cast = other instanceof JoinFailed ? other : THROW_CCE();
  if (!equals(this.nac_1, tmp0_other_with_cast.nac_1))
    return false;
  if (!(this.oac_1 === tmp0_other_with_cast.oac_1))
    return false;
  if (!(this.pac_1 == tmp0_other_with_cast.pac_1))
    return false;
  return true;
};
function Left(topic, joinRef) {
  ChannelLifecycleEvent.call(this);
  this.qac_1 = topic;
  this.rac_1 = joinRef;
}
protoOf(Left).toString = function () {
  return 'Left(topic=' + toString(this.qac_1) + ', joinRef=' + this.rac_1 + ')';
};
protoOf(Left).hashCode = function () {
  var result = hashCode(this.qac_1);
  result = imul(result, 31) + (this.rac_1 == null ? 0 : getStringHashCode(this.rac_1)) | 0;
  return result;
};
protoOf(Left).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Left))
    return false;
  var tmp0_other_with_cast = other instanceof Left ? other : THROW_CCE();
  if (!equals(this.qac_1, tmp0_other_with_cast.qac_1))
    return false;
  if (!(this.rac_1 == tmp0_other_with_cast.rac_1))
    return false;
  return true;
};
function Closed(topic, joinRef, reason) {
  ChannelLifecycleEvent.call(this);
  this.sac_1 = topic;
  this.tac_1 = joinRef;
  this.uac_1 = reason;
}
protoOf(Closed).toString = function () {
  return 'Closed(topic=' + toString(this.sac_1) + ', joinRef=' + this.tac_1 + ', reason=' + this.uac_1 + ')';
};
protoOf(Closed).hashCode = function () {
  var result = hashCode(this.sac_1);
  result = imul(result, 31) + (this.tac_1 == null ? 0 : getStringHashCode(this.tac_1)) | 0;
  result = imul(result, 31) + (this.uac_1 == null ? 0 : getStringHashCode(this.uac_1)) | 0;
  return result;
};
protoOf(Closed).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Closed))
    return false;
  var tmp0_other_with_cast = other instanceof Closed ? other : THROW_CCE();
  if (!equals(this.sac_1, tmp0_other_with_cast.sac_1))
    return false;
  if (!(this.tac_1 == tmp0_other_with_cast.tac_1))
    return false;
  if (!(this.uac_1 == tmp0_other_with_cast.uac_1))
    return false;
  return true;
};
function Error_0(topic, joinRef, reason) {
  ChannelLifecycleEvent.call(this);
  this.vac_1 = topic;
  this.wac_1 = joinRef;
  this.xac_1 = reason;
}
protoOf(Error_0).toString = function () {
  return 'Error(topic=' + toString(this.vac_1) + ', joinRef=' + this.wac_1 + ', reason=' + this.xac_1 + ')';
};
protoOf(Error_0).hashCode = function () {
  var result = hashCode(this.vac_1);
  result = imul(result, 31) + (this.wac_1 == null ? 0 : getStringHashCode(this.wac_1)) | 0;
  result = imul(result, 31) + (this.xac_1 == null ? 0 : getStringHashCode(this.xac_1)) | 0;
  return result;
};
protoOf(Error_0).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Error_0))
    return false;
  var tmp0_other_with_cast = other instanceof Error_0 ? other : THROW_CCE();
  if (!equals(this.vac_1, tmp0_other_with_cast.vac_1))
    return false;
  if (!(this.wac_1 == tmp0_other_with_cast.wac_1))
    return false;
  if (!(this.xac_1 == tmp0_other_with_cast.xac_1))
    return false;
  return true;
};
function ChannelLifecycleEvent() {
}
var CoreEvent_UNREAD_NOTIFICATION_COUNT_UPDATED_instance;
var CoreEvent_ANALYTICS_EVENT_instance;
function Companion_1() {
}
protoOf(Companion_1).yac = function (value) {
  var tmp0 = get_entries();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.bad_1 === value) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  return tmp$ret$1;
};
var Companion_instance_4;
function Companion_getInstance_4() {
  return Companion_instance_4;
}
function values() {
  return [CoreEvent_UNREAD_NOTIFICATION_COUNT_UPDATED_getInstance(), CoreEvent_ANALYTICS_EVENT_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var CoreEvent_entriesInitialized;
function CoreEvent_initEntries() {
  if (CoreEvent_entriesInitialized)
    return Unit_instance;
  CoreEvent_entriesInitialized = true;
  CoreEvent_UNREAD_NOTIFICATION_COUNT_UPDATED_instance = new CoreEvent('UNREAD_NOTIFICATION_COUNT_UPDATED', 0, 'unread-notification-count-updated');
  CoreEvent_ANALYTICS_EVENT_instance = new CoreEvent('ANALYTICS_EVENT', 1, 'analytics-event');
}
var $ENTRIES;
function Core(coreEvent) {
  Event.call(this);
  this.cad_1 = coreEvent;
  this.dad_1 = 'core:' + this.cad_1.bad_1;
}
protoOf(Core).ead = function () {
  return this.dad_1;
};
protoOf(Core).toString = function () {
  return 'Core(coreEvent=' + this.cad_1.toString() + ')';
};
protoOf(Core).hashCode = function () {
  return this.cad_1.hashCode();
};
protoOf(Core).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Core))
    return false;
  var tmp0_other_with_cast = other instanceof Core ? other : THROW_CCE();
  if (!this.cad_1.equals(tmp0_other_with_cast.cad_1))
    return false;
  return true;
};
function Unknown(raw) {
  Event.call(this);
  this.gad_1 = raw;
  this.had_1 = this.gad_1;
}
protoOf(Unknown).ead = function () {
  return this.had_1;
};
protoOf(Unknown).toString = function () {
  return 'Unknown(raw=' + this.gad_1 + ')';
};
protoOf(Unknown).hashCode = function () {
  return getStringHashCode(this.gad_1);
};
protoOf(Unknown).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Unknown))
    return false;
  var tmp0_other_with_cast = other instanceof Unknown ? other : THROW_CCE();
  if (!(this.gad_1 === tmp0_other_with_cast.gad_1))
    return false;
  return true;
};
function CoreEvent(name, ordinal, value) {
  Enum.call(this, name, ordinal);
  this.bad_1 = value;
}
function handleCoreEvent($this, topic, payload, joinRef, coreEvent) {
  var tmp;
  switch (topic.n1q().l2_1) {
    case 0:
      var payloadObject = payload instanceof JsonObject ? payload : null;
      var notificationEvent = Companion_instance_16.iad(coreEvent);
      var tmp_0;
      if (payloadObject == null) {
        tmp_0 = new WebSocketEventHandlingOutput(new Failure_0(new MessageIgnored(MessageIgnoredReason_UNSUPPORTED_PAYLOAD_getInstance())), listOf_0('\uD83E\uDDE6 WebSocket invalid payload type for notification'));
      } else if (notificationEvent == null) {
        tmp_0 = new WebSocketEventHandlingOutput(new Failure_0(new MessageIgnored(MessageIgnoredReason_UNSUPPORTED_EVENT_getInstance())), listOf_0('\uD83E\uDDE6 WebSocket event not exposed to consumers: ' + $this.ead()));
      } else {
        var notificationInfo = new NotificationInfo(joinRef, notificationEvent, payloadObject);
        tmp_0 = new WebSocketEventHandlingOutput(new Success_0(new NotificationReceived(notificationInfo)), listOf_0('\uD83E\uDDE6 WebSocket handled ' + topic.n1q().toString() + ': ' + $this.ead()));
      }

      tmp = tmp_0;
      break;
    case 1:
    case 2:
      tmp = new WebSocketEventHandlingOutput(new Failure_0(new MessageIgnored(MessageIgnoredReason_UNSUPPORTED_TOPIC_getInstance())), listOf_0('\uD83E\uDDE6 WebSocket topic not handled'));
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function handleUnknownEvent($this, topic) {
  var tmp;
  switch (topic.n1q().l2_1) {
    case 0:
      tmp = new WebSocketEventHandlingOutput(new Failure_0(new MessageIgnored(MessageIgnoredReason_UNSUPPORTED_EVENT_getInstance())), listOf_0('\uD83E\uDDE6 WebSocket unhandled ' + topic.n1q().toString() + ': ' + $this.ead()));
      break;
    case 1:
    case 2:
      tmp = new WebSocketEventHandlingOutput(new Failure_0(new MessageIgnored(MessageIgnoredReason_UNSUPPORTED_TOPIC_getInstance())), listOf_0('\uD83E\uDDE6 WebSocket topic ' + topic.n1q().toString() + ' not handled'));
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function Companion_2() {
}
protoOf(Companion_2).jad = function (from) {
  var components = split(from, [':'], VOID, 2);
  if (!(components.m() === 2))
    return null;
  var boundedContext = components.o(0);
  var eventName = components.o(1);
  var tmp;
  if (boundedContext === 'core') {
    var tmp1_elvis_lhs = Companion_instance_4.yac(eventName);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    tmp = new Core(tmp_0);
  } else {
    tmp = null;
  }
  return tmp;
};
var Companion_instance_5;
function Companion_getInstance_5() {
  return Companion_instance_5;
}
function CoreEvent_UNREAD_NOTIFICATION_COUNT_UPDATED_getInstance() {
  CoreEvent_initEntries();
  return CoreEvent_UNREAD_NOTIFICATION_COUNT_UPDATED_instance;
}
function CoreEvent_ANALYTICS_EVENT_getInstance() {
  CoreEvent_initEntries();
  return CoreEvent_ANALYTICS_EVENT_instance;
}
function Event() {
}
protoOf(Event).fad = function (topic, payload, joinRef) {
  var tmp;
  if (this instanceof Core) {
    tmp = handleCoreEvent(this, topic, payload, joinRef, this.cad_1);
  } else {
    if (this instanceof Unknown) {
      tmp = handleUnknownEvent(this, topic);
    } else {
      noWhenBranchMatchedException();
    }
  }
  return tmp;
};
function WebSocketEventHandlingOutput(result, breadcrumbs) {
  breadcrumbs = breadcrumbs === VOID ? emptyList() : breadcrumbs;
  this.kad_1 = result;
  this.lad_1 = breadcrumbs;
}
protoOf(WebSocketEventHandlingOutput).toString = function () {
  return 'WebSocketEventHandlingOutput(result=' + toString(this.kad_1) + ', breadcrumbs=' + toString(this.lad_1) + ')';
};
protoOf(WebSocketEventHandlingOutput).hashCode = function () {
  var result = hashCode(this.kad_1);
  result = imul(result, 31) + hashCode(this.lad_1) | 0;
  return result;
};
protoOf(WebSocketEventHandlingOutput).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WebSocketEventHandlingOutput))
    return false;
  var tmp0_other_with_cast = other instanceof WebSocketEventHandlingOutput ? other : THROW_CCE();
  if (!equals(this.kad_1, tmp0_other_with_cast.kad_1))
    return false;
  if (!equals(this.lad_1, tmp0_other_with_cast.lad_1))
    return false;
  return true;
};
function Success_0(action) {
  MessageResult.call(this);
  this.mad_1 = action;
}
protoOf(Success_0).toString = function () {
  return 'Success(action=' + toString(this.mad_1) + ')';
};
protoOf(Success_0).hashCode = function () {
  return hashCode(this.mad_1);
};
protoOf(Success_0).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Success_0))
    return false;
  var tmp0_other_with_cast = other instanceof Success_0 ? other : THROW_CCE();
  if (!equals(this.mad_1, tmp0_other_with_cast.mad_1))
    return false;
  return true;
};
function Channel_0(event) {
  MessageResult.call(this);
  this.nad_1 = event;
}
protoOf(Channel_0).toString = function () {
  return 'Channel(event=' + toString(this.nad_1) + ')';
};
protoOf(Channel_0).hashCode = function () {
  return hashCode(this.nad_1);
};
protoOf(Channel_0).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Channel_0))
    return false;
  var tmp0_other_with_cast = other instanceof Channel_0 ? other : THROW_CCE();
  if (!equals(this.nad_1, tmp0_other_with_cast.nad_1))
    return false;
  return true;
};
function Failure_0(error) {
  MessageResult.call(this);
  this.oad_1 = error;
}
protoOf(Failure_0).toString = function () {
  return 'Failure(error=' + toString(this.oad_1) + ')';
};
protoOf(Failure_0).hashCode = function () {
  return hashCode(this.oad_1);
};
protoOf(Failure_0).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Failure_0))
    return false;
  var tmp0_other_with_cast = other instanceof Failure_0 ? other : THROW_CCE();
  if (!equals(this.oad_1, tmp0_other_with_cast.oad_1))
    return false;
  return true;
};
function MessageResult() {
}
function MessageFailed() {
  MessageFailed_instance = this;
  MessageError.call(this);
}
protoOf(MessageFailed).toString = function () {
  return 'MessageFailed';
};
protoOf(MessageFailed).hashCode = function () {
  return -655799689;
};
protoOf(MessageFailed).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof MessageFailed))
    return false;
  other instanceof MessageFailed || THROW_CCE();
  return true;
};
var MessageFailed_instance;
function MessageFailed_getInstance() {
  if (MessageFailed_instance == null)
    new MessageFailed();
  return MessageFailed_instance;
}
function MessageIgnored(reason) {
  MessageError.call(this);
  this.pad_1 = reason;
}
protoOf(MessageIgnored).toString = function () {
  return 'MessageIgnored(reason=' + this.pad_1.toString() + ')';
};
protoOf(MessageIgnored).hashCode = function () {
  return this.pad_1.hashCode();
};
protoOf(MessageIgnored).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof MessageIgnored))
    return false;
  var tmp0_other_with_cast = other instanceof MessageIgnored ? other : THROW_CCE();
  if (!this.pad_1.equals(tmp0_other_with_cast.pad_1))
    return false;
  return true;
};
function MessageError() {
}
var MessageIgnoredReason_UNEXPECTED_JOIN_instance;
var MessageIgnoredReason_UNEXPECTED_LEAVE_instance;
var MessageIgnoredReason_UNSUPPORTED_TOPIC_instance;
var MessageIgnoredReason_UNSUPPORTED_EVENT_instance;
var MessageIgnoredReason_UNSUPPORTED_PAYLOAD_instance;
var MessageIgnoredReason_UNKNOWN_instance;
var MessageIgnoredReason_entriesInitialized;
function MessageIgnoredReason_initEntries() {
  if (MessageIgnoredReason_entriesInitialized)
    return Unit_instance;
  MessageIgnoredReason_entriesInitialized = true;
  MessageIgnoredReason_UNEXPECTED_JOIN_instance = new MessageIgnoredReason('UNEXPECTED_JOIN', 0);
  MessageIgnoredReason_UNEXPECTED_LEAVE_instance = new MessageIgnoredReason('UNEXPECTED_LEAVE', 1);
  MessageIgnoredReason_UNSUPPORTED_TOPIC_instance = new MessageIgnoredReason('UNSUPPORTED_TOPIC', 2);
  MessageIgnoredReason_UNSUPPORTED_EVENT_instance = new MessageIgnoredReason('UNSUPPORTED_EVENT', 3);
  MessageIgnoredReason_UNSUPPORTED_PAYLOAD_instance = new MessageIgnoredReason('UNSUPPORTED_PAYLOAD', 4);
  MessageIgnoredReason_UNKNOWN_instance = new MessageIgnoredReason('UNKNOWN', 5);
}
function MessageIgnoredReason(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function MessageIgnoredReason_UNEXPECTED_JOIN_getInstance() {
  MessageIgnoredReason_initEntries();
  return MessageIgnoredReason_UNEXPECTED_JOIN_instance;
}
function MessageIgnoredReason_UNSUPPORTED_TOPIC_getInstance() {
  MessageIgnoredReason_initEntries();
  return MessageIgnoredReason_UNSUPPORTED_TOPIC_instance;
}
function MessageIgnoredReason_UNSUPPORTED_EVENT_getInstance() {
  MessageIgnoredReason_initEntries();
  return MessageIgnoredReason_UNSUPPORTED_EVENT_instance;
}
function MessageIgnoredReason_UNSUPPORTED_PAYLOAD_getInstance() {
  MessageIgnoredReason_initEntries();
  return MessageIgnoredReason_UNSUPPORTED_PAYLOAD_instance;
}
function MessageIgnoredReason_UNKNOWN_getInstance() {
  MessageIgnoredReason_initEntries();
  return MessageIgnoredReason_UNKNOWN_instance;
}
function Notifications(userId) {
  Topic.call(this);
  this.qad_1 = userId;
  this.rad_1 = Channel_NOTIFICATIONS_getInstance();
  this.sad_1 = this.rad_1.kac_1 + ':' + this.qad_1;
}
protoOf(Notifications).n1q = function () {
  return this.rad_1;
};
protoOf(Notifications).ead = function () {
  return this.sad_1;
};
protoOf(Notifications).toString = function () {
  return 'Notifications(userId=' + this.qad_1 + ')';
};
protoOf(Notifications).hashCode = function () {
  return this.qad_1;
};
protoOf(Notifications).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Notifications))
    return false;
  var tmp0_other_with_cast = other instanceof Notifications ? other : THROW_CCE();
  if (!(this.qad_1 === tmp0_other_with_cast.qad_1))
    return false;
  return true;
};
function Analytics(userId) {
  Topic.call(this);
  this.tad_1 = userId;
  this.uad_1 = Channel_ANALYTICS_getInstance();
  this.vad_1 = this.uad_1.kac_1 + ':' + this.tad_1;
}
protoOf(Analytics).n1q = function () {
  return this.uad_1;
};
protoOf(Analytics).ead = function () {
  return this.vad_1;
};
protoOf(Analytics).toString = function () {
  return 'Analytics(userId=' + this.tad_1 + ')';
};
protoOf(Analytics).hashCode = function () {
  return this.tad_1;
};
protoOf(Analytics).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Analytics))
    return false;
  var tmp0_other_with_cast = other instanceof Analytics ? other : THROW_CCE();
  if (!(this.tad_1 === tmp0_other_with_cast.tad_1))
    return false;
  return true;
};
function Unknown_0(raw) {
  Topic.call(this);
  this.wad_1 = raw;
  this.xad_1 = Channel_UNKNOWN_getInstance();
  this.yad_1 = this.wad_1;
  this.zad_1 = null;
}
protoOf(Unknown_0).n1q = function () {
  return this.xad_1;
};
protoOf(Unknown_0).ead = function () {
  return this.yad_1;
};
protoOf(Unknown_0).toString = function () {
  return 'Unknown(raw=' + this.wad_1 + ')';
};
protoOf(Unknown_0).hashCode = function () {
  return getStringHashCode(this.wad_1);
};
protoOf(Unknown_0).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Unknown_0))
    return false;
  var tmp0_other_with_cast = other instanceof Unknown_0 ? other : THROW_CCE();
  if (!(this.wad_1 === tmp0_other_with_cast.wad_1))
    return false;
  return true;
};
function Companion_3() {
}
protoOf(Companion_3).aae = function (raw) {
  var components = split(raw, [':']);
  var tmp;
  if (components.m() === 2) {
    var channelName = components.o(0);
    var userId = toIntOrNull(components.o(1));
    var tmp_0;
    if (!(userId == null)) {
      tmp_0 = channelName === Channel_NOTIFICATIONS_getInstance().kac_1 ? new Notifications(userId) : channelName === Channel_ANALYTICS_getInstance().kac_1 ? new Analytics(userId) : new Unknown_0(raw);
    } else {
      tmp_0 = new Unknown_0(raw);
    }
    tmp = tmp_0;
  } else {
    tmp = new Unknown_0(raw);
  }
  return tmp;
};
var Companion_instance_6;
function Companion_getInstance_6() {
  return Companion_instance_6;
}
function Topic() {
}
function WebSocketConnectionRequest(url, authProtocolHeader) {
  this.bae_1 = url;
  this.cae_1 = authProtocolHeader;
}
protoOf(WebSocketConnectionRequest).toString = function () {
  return 'WebSocketConnectionRequest(url=' + this.bae_1 + ', authProtocolHeader=' + this.cae_1 + ')';
};
protoOf(WebSocketConnectionRequest).hashCode = function () {
  var result = getStringHashCode(this.bae_1);
  result = imul(result, 31) + getStringHashCode(this.cae_1) | 0;
  return result;
};
protoOf(WebSocketConnectionRequest).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WebSocketConnectionRequest))
    return false;
  var tmp0_other_with_cast = other instanceof WebSocketConnectionRequest ? other : THROW_CCE();
  if (!(this.bae_1 === tmp0_other_with_cast.bae_1))
    return false;
  if (!(this.cae_1 === tmp0_other_with_cast.cae_1))
    return false;
  return true;
};
function WebSocketToken(token) {
  this.dae_1 = token;
}
protoOf(WebSocketToken).toString = function () {
  return 'WebSocketToken(token=' + this.dae_1 + ')';
};
protoOf(WebSocketToken).hashCode = function () {
  return getStringHashCode(this.dae_1);
};
protoOf(WebSocketToken).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WebSocketToken))
    return false;
  var tmp0_other_with_cast = other instanceof WebSocketToken ? other : THROW_CCE();
  if (!(this.dae_1 === tmp0_other_with_cast.dae_1))
    return false;
  return true;
};
function closeSessionAndCleanup($this, $completion) {
  var tmp = new $closeSessionAndCleanupCOROUTINE$12($this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function establishConnection($this, userId, $completion) {
  var tmp = new $establishConnectionCOROUTINE$14($this, userId, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function receiveMessages($this, userId, $completion) {
  var tmp = new $receiveMessagesCOROUTINE$15($this, userId, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function handleSuccessfulMessage($this, action, $completion) {
  var tmp = new $handleSuccessfulMessageCOROUTINE$16($this, action, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function handleMessageError($this, error) {
  if (error instanceof MessageFailed) {
    reportWebSocketIssue($this.jag_1, 'Inbound message handling failed', Impact_LOW_getInstance());
  } else {
    if (!(error instanceof MessageIgnored)) {
      noWhenBranchMatchedException();
    }
  }
}
function attemptReconnection($this, userId, $completion) {
  var tmp = new $attemptReconnectionCOROUTINE$17($this, userId, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function joinDefaultChannels($this, userId, $completion) {
  var tmp = new $joinDefaultChannelsCOROUTINE$18($this, userId, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function startPing($this) {
  var tmp0_safe_receiver = $this.pag_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    $this.fag_1.sah($this.kag_1, tmp0_safe_receiver, WebSocketClient$startPing$lambda($this));
  }
}
function WebSocketClient$connect$slambda(this$0, $userId, resultContinuation) {
  this.bai_1 = this$0;
  this.cai_1 = $userId;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(WebSocketClient$connect$slambda).r3m = function ($this$launch, $completion) {
  var tmp = this.s3m($this$launch, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(WebSocketClient$connect$slambda).h9 = function (p1, $completion) {
  return this.r3m((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(WebSocketClient$connect$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = receiveMessages(this.bai_1, this.cai_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(WebSocketClient$connect$slambda).s3m = function ($this$launch, completion) {
  var i = new WebSocketClient$connect$slambda(this.bai_1, this.cai_1, completion);
  i.dai_1 = $this$launch;
  return i;
};
function WebSocketClient$connect$slambda_0(this$0, $userId, resultContinuation) {
  var i = new WebSocketClient$connect$slambda(this$0, $userId, resultContinuation);
  var l = function ($this$launch, $completion) {
    return i.r3m($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function WebSocketClient$attemptReconnection$slambda(this$0, $userId, resultContinuation) {
  this.mai_1 = this$0;
  this.nai_1 = $userId;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(WebSocketClient$attemptReconnection$slambda).r3m = function ($this$launch, $completion) {
  var tmp = this.s3m($this$launch, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(WebSocketClient$attemptReconnection$slambda).h9 = function (p1, $completion) {
  return this.r3m((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(WebSocketClient$attemptReconnection$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = joinDefaultChannels(this.mai_1, this.nai_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(WebSocketClient$attemptReconnection$slambda).s3m = function ($this$launch, completion) {
  var i = new WebSocketClient$attemptReconnection$slambda(this.mai_1, this.nai_1, completion);
  i.oai_1 = $this$launch;
  return i;
};
function WebSocketClient$attemptReconnection$slambda_0(this$0, $userId, resultContinuation) {
  var i = new WebSocketClient$attemptReconnection$slambda(this$0, $userId, resultContinuation);
  var l = function ($this$launch, $completion) {
    return i.r3m($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function WebSocketClient$startPing$lambda(this$0) {
  return function (result) {
    // Inline function 'kotlin.onFailure' call
    var this_0 = result.ul_1;
    var tmp0_safe_receiver = Result__exceptionOrNull_impl_p6xea9(this_0);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      reportWebSocketIssue(this$0.jag_1, 'Ping failed', Impact_MEDIUM_getInstance(), VOID, tmp0_safe_receiver);
    }
    return Unit_instance;
  };
}
function $connectCOROUTINE$10(_this__u8e3s4, userId, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.xai_1 = _this__u8e3s4;
  this.yai_1 = userId;
}
protoOf($connectCOROUTINE$10).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 5;
          this.xai_1.lag_1.s22(Connecting_getInstance());
          webSocketBreadcrumb(this.xai_1.jag_1, 'client connecting');
          this.o8_1 = 3;
          this.n8_1 = 1;
          suspendResult = establishConnection(this.xai_1, this.yai_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.xai_1.lag_1.s22(Connected_getInstance());
          webSocketBreadcrumb(this.xai_1.jag_1, 'client connected');
          var tmp_0 = this.xai_1;
          tmp_0.qag_1 = launch(this.xai_1.kag_1, VOID, VOID, WebSocketClient$connect$slambda_0(this.xai_1, this.yai_1, null));
          this.n8_1 = 2;
          suspendResult = joinDefaultChannels(this.xai_1, this.yai_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.o8_1 = 5;
          this.n8_1 = 4;
          continue $sm;
        case 3:
          this.o8_1 = 5;
          var tmp_1 = this.q8_1;
          if (tmp_1 instanceof CancellationException) {
            var e = this.q8_1;
            throw e;
          } else {
            var tmp_2 = this.q8_1;
            if (tmp_2 instanceof Exception) {
              var e_0 = this.q8_1;
              reportWebSocketIssue(this.xai_1.jag_1, 'Client failed to establish connection', Impact_HIGH_getInstance(), VOID, e_0);
              var tmp0_elvis_lhs = e_0.message;
              this.xai_1.lag_1.s22(new Failed(tmp0_elvis_lhs == null ? 'Unknown error' : tmp0_elvis_lhs));
              this.n8_1 = 4;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 4:
          this.o8_1 = 5;
          return Unit_instance;
        case 5:
          throw this.q8_1;
      }
    } catch ($p) {
      var e_1 = $p;
      if (this.o8_1 === 5) {
        throw e_1;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_1;
      }
    }
   while (true);
};
function $disconnectCOROUTINE$11(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.haj_1 = _this__u8e3s4;
}
protoOf($disconnectCOROUTINE$11).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          this.iaj_1 = this.haj_1.qag_1;
          if (this.iaj_1 == null) {
            this.jaj_1 = null;
            this.n8_1 = 2;
            continue $sm;
          } else {
            this.n8_1 = 1;
            suspendResult = cancelAndJoin(this.iaj_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          }

        case 1:
          var tmp_0 = this;
          tmp_0.jaj_1 = Unit_instance;
          this.n8_1 = 2;
          continue $sm;
        case 2:
          this.haj_1.qag_1 = null;
          this.n8_1 = 3;
          suspendResult = closeSessionAndCleanup(this.haj_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 3:
          this.haj_1.lag_1.s22(Disconnected_getInstance());
          webSocketBreadcrumb(this.haj_1.jag_1, 'client disconnected');
          return Unit_instance;
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $closeSessionAndCleanupCOROUTINE$12(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.mae_1 = _this__u8e3s4;
}
protoOf($closeSessionAndCleanupCOROUTINE$12).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          this.mae_1.fag_1.kaj();
          this.nae_1 = this.mae_1.pag_1;
          if (this.nae_1 == null) {
            this.oae_1 = null;
            this.n8_1 = 2;
            continue $sm;
          } else {
            this.n8_1 = 1;
            suspendResult = this.nae_1.laj(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          }

        case 1:
          var tmp_0 = this;
          tmp_0.oae_1 = Unit_instance;
          this.n8_1 = 2;
          continue $sm;
        case 2:
          this.mae_1.pag_1 = null;
          this.n8_1 = 3;
          suspendResult = this.mae_1.iag_1.maj(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 3:
          return Unit_instance;
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $establishConnectionCOROUTINE$14(_this__u8e3s4, userId, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.xae_1 = _this__u8e3s4;
  this.yae_1 = userId;
}
protoOf($establishConnectionCOROUTINE$14).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 4;
          this.n8_1 = 1;
          suspendResult = this.xae_1.cag_1.naj(this.yae_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.zae_1 = suspendResult;
          this.n8_1 = 2;
          suspendResult = this.xae_1.dag_1.oaj(this.zae_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.aaf_1 = suspendResult;
          this.xae_1.pag_1 = this.aaf_1;
          this.n8_1 = 3;
          suspendResult = this.xae_1.iag_1.maj(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 3:
          startPing(this.xae_1);
          return Unit_instance;
        case 4:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 4) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $receiveMessagesCOROUTINE$15(_this__u8e3s4, userId, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.jaf_1 = _this__u8e3s4;
  this.kaf_1 = userId;
}
protoOf($receiveMessagesCOROUTINE$15).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 14;
          this.n8_1 = 1;
          continue $sm;
        case 1:
          if (!true) {
            this.n8_1 = 15;
            continue $sm;
          }

          this.o8_1 = 8;
          this.laf_1 = this.jaf_1.pag_1;
          if (this.laf_1 == null) {
            webSocketBreadcrumb(this.jaf_1.jag_1, 'receive loop ended: session closed');
            this.o8_1 = 14;
            this.n8_1 = 15;
            continue $sm;
          } else {
            this.n8_1 = 2;
            continue $sm;
          }

        case 2:
          this.n8_1 = 3;
          suspendResult = this.laf_1.paj(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 3:
          this.maf_1 = suspendResult;
          var tmp_0 = this.maf_1;
          if (tmp_0 instanceof Text) {
            this.jaf_1.rag_1 = 0;
            this.naf_1 = readText(this.maf_1);
            this.oaf_1 = this.jaf_1.gag_1.qaj(this.naf_1);
            var tmp_1 = this.oaf_1;
            if (tmp_1 instanceof Success_0) {
              this.n8_1 = 5;
              suspendResult = handleSuccessfulMessage(this.jaf_1, this.oaf_1.mad_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_2 = this.oaf_1;
              if (tmp_2 instanceof Channel_0) {
                this.n8_1 = 4;
                suspendResult = this.jaf_1.iag_1.raj(this.oaf_1.nad_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_3 = this.oaf_1;
                if (tmp_3 instanceof Failure_0) {
                  handleMessageError(this.jaf_1, this.oaf_1.oad_1);
                  this.n8_1 = 6;
                  continue $sm;
                } else {
                  noWhenBranchMatchedException();
                }
              }
            }
          } else {
            this.n8_1 = 7;
            continue $sm;
          }

          break;
        case 4:
          this.n8_1 = 6;
          continue $sm;
        case 5:
          this.n8_1 = 6;
          continue $sm;
        case 6:
          this.n8_1 = 7;
          continue $sm;
        case 7:
          this.o8_1 = 14;
          this.n8_1 = 13;
          continue $sm;
        case 8:
          this.o8_1 = 14;
          var tmp_4 = this.q8_1;
          if (tmp_4 instanceof CancellationException) {
            this.paf_1 = this.q8_1;
            throw this.paf_1;
          } else {
            var tmp_5 = this.q8_1;
            if (tmp_5 instanceof Exception) {
              this.qaf_1 = this.q8_1;
              var tmp0_elvis_lhs = this.qaf_1.message;
              webSocketBreadcrumb(this.jaf_1.jag_1, 'receive error: ' + (tmp0_elvis_lhs == null ? getKClassFromExpression(this.qaf_1).pa() : tmp0_elvis_lhs));
              if (this.jaf_1.eag_1.saj(this.qaf_1, this.jaf_1.rag_1)) {
                this.n8_1 = 10;
                suspendResult = attemptReconnection(this.jaf_1, this.kaf_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                reportWebSocketIssue(this.jaf_1.jag_1, 'Receive loop terminated, not reconnecting', Impact_HIGH_getInstance(), mapOf(to('reconnectAttempts', this.jaf_1.rag_1.toString())), this.qaf_1);
                var tmp1_elvis_lhs = this.qaf_1.message;
                this.jaf_1.lag_1.s22(new Failed(tmp1_elvis_lhs == null ? 'Unknown error' : tmp1_elvis_lhs));
                this.n8_1 = 9;
                suspendResult = closeSessionAndCleanup(this.jaf_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              }
            } else {
              throw this.q8_1;
            }
          }

        case 9:
          this.n8_1 = 15;
          continue $sm;
        case 10:
          var ARGUMENT = suspendResult;
          if (!ARGUMENT) {
            this.n8_1 = 15;
            continue $sm;
          } else {
            this.n8_1 = 11;
            continue $sm;
          }

        case 11:
          this.n8_1 = 12;
          continue $sm;
        case 12:
          this.n8_1 = 13;
          continue $sm;
        case 13:
          this.o8_1 = 14;
          this.n8_1 = 1;
          continue $sm;
        case 14:
          throw this.q8_1;
        case 15:
          return Unit_instance;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 14) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $handleSuccessfulMessageCOROUTINE$16(_this__u8e3s4, action, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.zaf_1 = _this__u8e3s4;
  this.aag_1 = action;
}
protoOf($handleSuccessfulMessageCOROUTINE$16).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.bag_1 = this.aag_1;
          var tmp_0 = this.bag_1;
          if (tmp_0 instanceof NotificationReceived) {
            webSocketBreadcrumb(this.zaf_1.jag_1, 'notification received: ' + this.aag_1.waj_1.uaj_1.k2_1);
            this.n8_1 = 1;
            suspendResult = this.zaf_1.nag_1.b1z(this.aag_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            noWhenBranchMatchedException();
          }

          break;
        case 1:
          this.n8_1 = 2;
          continue $sm;
        case 2:
          return Unit_instance;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $attemptReconnectionCOROUTINE$17(_this__u8e3s4, userId, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.aah_1 = _this__u8e3s4;
  this.bah_1 = userId;
}
protoOf($attemptReconnectionCOROUTINE$17).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 7;
          var _unary__edvuaz = this.aah_1.rag_1;
          this.aah_1.rag_1 = _unary__edvuaz + 1 | 0;
          this.n8_1 = 1;
          suspendResult = closeSessionAndCleanup(this.aah_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.aah_1.lag_1.s22(new Reconnecting(this.aah_1.rag_1));
          this.cah_1 = this.aah_1.eag_1.xaj(this.aah_1.rag_1 - 1 | 0);
          webSocketBreadcrumb(this.aah_1.jag_1, 'reconnecting (attempt ' + this.aah_1.rag_1 + ', in ' + this.cah_1 + 's)');
          this.n8_1 = 2;
          suspendResult = delay(numberToLong(this.cah_1 * 1000), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.o8_1 = 4;
          this.n8_1 = 3;
          suspendResult = establishConnection(this.aah_1, this.bah_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 3:
          this.aah_1.lag_1.s22(Connected_getInstance());
          webSocketBreadcrumb(this.aah_1.jag_1, 'reconnected (attempt ' + this.aah_1.rag_1 + ')');
          launch(this.aah_1.kag_1, VOID, VOID, WebSocketClient$attemptReconnection$slambda_0(this.aah_1, this.bah_1, null));
          this.dah_1 = true;
          this.o8_1 = 7;
          this.n8_1 = 6;
          continue $sm;
        case 4:
          this.o8_1 = 7;
          var tmp_0 = this.q8_1;
          if (tmp_0 instanceof CancellationException) {
            this.eah_1 = this.q8_1;
            var tmp_1 = this;
            throw this.eah_1;
          } else {
            var tmp_2 = this.q8_1;
            if (tmp_2 instanceof Exception) {
              this.fah_1 = this.q8_1;
              reportWebSocketIssue(this.aah_1.jag_1, 'Reconnection attempt failed', Impact_HIGH_getInstance(), mapOf(to('attempt', this.aah_1.rag_1.toString())), this.fah_1);
              var tmp0_elvis_lhs = this.fah_1.message;
              this.aah_1.lag_1.s22(new Failed(tmp0_elvis_lhs == null ? 'Unknown error' : tmp0_elvis_lhs));
              this.n8_1 = 5;
              suspendResult = closeSessionAndCleanup(this.aah_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 5:
          this.dah_1 = false;
          this.n8_1 = 6;
          continue $sm;
        case 6:
          this.o8_1 = 7;
          return this.dah_1;
        case 7:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 7) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $joinDefaultChannelsCOROUTINE$18(_this__u8e3s4, userId, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.oah_1 = _this__u8e3s4;
  this.pah_1 = userId;
}
protoOf($joinDefaultChannelsCOROUTINE$18).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          this.o8_1 = 2;
          var tmp_0 = this;
          var tmp0_elvis_lhs = this.oah_1.pag_1;
          var tmp_1;
          if (tmp0_elvis_lhs == null) {
            return Unit_instance;
          } else {
            tmp_1 = tmp0_elvis_lhs;
          }

          tmp_0.rah_1 = tmp_1;
          this.n8_1 = 1;
          suspendResult = this.oah_1.iag_1.yaj(new Notifications(this.pah_1), this.rah_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.qah_1 = suspendResult;
          this.o8_1 = 3;
          this.n8_1 = 4;
          continue $sm;
        case 2:
          this.o8_1 = 3;
          var tmp_2 = this.q8_1;
          if (tmp_2 instanceof CancellationException) {
            var e = this.q8_1;
            var tmp_3 = this;
            throw e;
          } else {
            var tmp_4 = this.q8_1;
            if (tmp_4 instanceof Exception) {
              var e_0 = this.q8_1;
              var tmp_5 = this;
              reportWebSocketIssue(this.oah_1.jag_1, 'Failed to join default channel', Impact_LOW_getInstance(), VOID, e_0);
              tmp_5.qah_1 = Unit_instance;
              this.n8_1 = 4;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 3:
          throw this.q8_1;
        case 4:
          this.o8_1 = 3;
          return Unit_instance;
      }
    } catch ($p) {
      var e_1 = $p;
      if (this.o8_1 === 3) {
        throw e_1;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e_1;
      }
    }
   while (true);
};
function WebSocketClient(getWebSocketConnectionRequestUseCase, webSocketSessionFactory, reconnectionStrategy, pingTask, messageHandler, messageSender, channelHandler, logger, scope) {
  scope = scope === VOID ? CoroutineScope_0(SupervisorJob()) : scope;
  this.cag_1 = getWebSocketConnectionRequestUseCase;
  this.dag_1 = webSocketSessionFactory;
  this.eag_1 = reconnectionStrategy;
  this.fag_1 = pingTask;
  this.gag_1 = messageHandler;
  this.hag_1 = messageSender;
  this.iag_1 = channelHandler;
  this.jag_1 = logger;
  this.kag_1 = scope;
  this.lag_1 = MutableStateFlow(Disconnected_getInstance());
  this.mag_1 = asStateFlow(this.lag_1);
  this.nag_1 = MutableSharedFlow(VOID, 64);
  this.oag_1 = asSharedFlow(this.nag_1);
  this.pag_1 = null;
  this.qag_1 = null;
  this.rag_1 = 0;
}
protoOf(WebSocketClient).za8 = function () {
  return this.mag_1;
};
protoOf(WebSocketClient).la9 = function () {
  return this.oag_1;
};
protoOf(WebSocketClient).na9 = function (userId, $completion) {
  var tmp = new $connectCOROUTINE$10(this, userId, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(WebSocketClient).oa9 = function ($completion) {
  var tmp = new $disconnectCOROUTINE$11(this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
function IWebSocketClientFactory() {
}
function WebSocketClientFactory(getWebSocketConnectionRequestUseCase, webSocketSessionFactory, phoenixRefGeneratorProvider, messageHandlerProvider, pingTaskProvider, reconnectionStrategyProvider, logger) {
  this.zaj_1 = getWebSocketConnectionRequestUseCase;
  this.aak_1 = webSocketSessionFactory;
  this.bak_1 = phoenixRefGeneratorProvider;
  this.cak_1 = messageHandlerProvider;
  this.dak_1 = pingTaskProvider;
  this.eak_1 = reconnectionStrategyProvider;
  this.fak_1 = logger;
}
protoOf(WebSocketClientFactory).ma9 = function () {
  var phoenixRefGenerator = this.bak_1();
  var messageSender = new WebSocketMessageSender(phoenixRefGenerator, this.fak_1);
  var channelHandler = new WebSocketChannelHandler(phoenixRefGenerator, this.fak_1);
  return new WebSocketClient(this.zaj_1, this.aak_1, this.eak_1(), this.dak_1(), this.cak_1(), messageSender, channelHandler, this.fak_1);
};
function IWebSocketEventFactory() {
}
function IWebSocketMessageHandler() {
}
function channelMetadata($this, topic, reason) {
  var tmp = to('topic', topic.ead());
  return mapOf_0([tmp, to('reason', reason == null ? 'unknown' : reason)]);
}
function waitForJoinCompletion($this, topic, $completion) {
  var tmp = new $waitForJoinCompletionCOROUTINE$21($this, topic, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function sendJoinMessage($this, topic, joinRef, session, $completion) {
  var outboundMessage = new PhoenixOutboundMessage(joinRef, joinRef, topic, Join_getInstance(), emptyMap());
  return session.xak(outboundMessage.wak(), $completion);
}
function Companion_4() {
  Companion_instance_7 = this;
  this.yak_1 = new Long(10000, 0);
}
var Companion_instance_7;
function Companion_getInstance_7() {
  if (Companion_instance_7 == null)
    new Companion_4();
  return Companion_instance_7;
}
function WebSocketChannelHandler$resetForNewConnection$lambda(topicKey) {
  return Companion_instance_8.zak(Companion_instance_6.aae(topicKey));
}
function WebSocketChannelHandler$waitForJoinCompletion$slambda(this$0, $topic, resultContinuation) {
  this.ial_1 = this$0;
  this.jal_1 = $topic;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(WebSocketChannelHandler$waitForJoinCompletion$slambda).lal = function ($this$withTimeoutOrNull, $completion) {
  var tmp = this.s3m($this$withTimeoutOrNull, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(WebSocketChannelHandler$waitForJoinCompletion$slambda).h9 = function (p1, $completion) {
  return this.lal((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(WebSocketChannelHandler$waitForJoinCompletion$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.ial_1.oal_1.sal(this.jal_1.ead(), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          return suspendResult;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(WebSocketChannelHandler$waitForJoinCompletion$slambda).s3m = function ($this$withTimeoutOrNull, completion) {
  var i = new WebSocketChannelHandler$waitForJoinCompletion$slambda(this.ial_1, this.jal_1, completion);
  i.kal_1 = $this$withTimeoutOrNull;
  return i;
};
function WebSocketChannelHandler$waitForJoinCompletion$slambda_0(this$0, $topic, resultContinuation) {
  var i = new WebSocketChannelHandler$waitForJoinCompletion$slambda(this$0, $topic, resultContinuation);
  var l = function ($this$withTimeoutOrNull, $completion) {
    return i.lal($this$withTimeoutOrNull, $completion);
  };
  l.$arity = 1;
  return l;
}
function $joinCOROUTINE$19(_this__u8e3s4, topic, session, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.bam_1 = _this__u8e3s4;
  this.cam_1 = topic;
  this.dam_1 = session;
}
protoOf($joinCOROUTINE$19).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 8;
          this.eam_1 = this.cam_1.ead();
          this.n8_1 = 1;
          suspendResult = this.bam_1.mal_1.mam(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          this.fam_1 = suspendResult;
          this.n8_1 = 2;
          suspendResult = this.bam_1.oal_1.nam(this.eam_1, this.fam_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.gam_1 = suspendResult;
          this.ham_1 = this.gam_1.oam();
          this.o8_1 = 6;
          var tmp_0 = this.gam_1;
          if (tmp_0 instanceof StartNew) {
            this.n8_1 = 3;
            suspendResult = sendJoinMessage(this.bam_1, this.cam_1, this.ham_1, this.dam_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            this.n8_1 = 4;
            continue $sm;
          }

        case 3:
          this.n8_1 = 4;
          continue $sm;
        case 4:
          this.n8_1 = 5;
          suspendResult = waitForJoinCompletion(this.bam_1, this.cam_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 5:
          return suspendResult;
        case 6:
          this.o8_1 = 8;
          var tmp_1 = this.q8_1;
          if (tmp_1 instanceof CancellationException) {
            this.iam_1 = this.q8_1;
            throw this.iam_1;
          } else {
            var tmp_2 = this.q8_1;
            if (tmp_2 instanceof Exception) {
              this.jam_1 = this.q8_1;
              this.n8_1 = 7;
              suspendResult = this.bam_1.oal_1.pam(this.eam_1, this.ham_1, this.jam_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 7:
          throw this.jam_1;
        case 8:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 8) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $handleCOROUTINE$20(_this__u8e3s4, event, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.yam_1 = _this__u8e3s4;
  this.zam_1 = event;
}
protoOf($handleCOROUTINE$20).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 7;
          this.aan_1 = this.zam_1;
          var tmp_0 = this.aan_1;
          if (tmp_0 instanceof JoinSucceeded) {
            webSocketBreadcrumb(this.yam_1.nal_1, 'channel joined: ' + this.zam_1.lac_1.ead());
            this.n8_1 = 5;
            suspendResult = this.yam_1.oal_1.gan(this.zam_1.lac_1.ead(), this.zam_1.mac_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }
            continue $sm;
          } else {
            var tmp_1 = this.aan_1;
            if (tmp_1 instanceof JoinFailed) {
              reportWebSocketIssue(this.yam_1.nal_1, 'Channel join failed', Impact_MEDIUM_getInstance(), channelMetadata(this.yam_1, this.zam_1.nac_1, this.zam_1.pac_1));
              this.n8_1 = 4;
              suspendResult = this.yam_1.oal_1.pam(this.zam_1.nac_1.ead(), this.zam_1.oac_1, Companion_instance_8.fan(this.zam_1.nac_1, this.zam_1.pac_1), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              var tmp_2 = this.aan_1;
              if (tmp_2 instanceof Left) {
                webSocketBreadcrumb(this.yam_1.nal_1, 'channel left: ' + this.zam_1.qac_1.ead());
                this.n8_1 = 3;
                suspendResult = this.yam_1.oal_1.ean(this.zam_1.qac_1.ead(), this.zam_1.rac_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                var tmp_3 = this.aan_1;
                if (tmp_3 instanceof Closed) {
                  reportWebSocketIssue(this.yam_1.nal_1, 'Channel closed', Impact_MEDIUM_getInstance(), channelMetadata(this.yam_1, this.zam_1.sac_1, this.zam_1.uac_1));
                  this.n8_1 = 2;
                  suspendResult = this.yam_1.oal_1.can(this.zam_1.sac_1.ead(), this.zam_1.tac_1, Companion_instance_8.dan(this.zam_1.sac_1, this.zam_1.uac_1), this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  var tmp_4 = this.aan_1;
                  if (tmp_4 instanceof Error_0) {
                    reportWebSocketIssue(this.yam_1.nal_1, 'Channel error', Impact_MEDIUM_getInstance(), channelMetadata(this.yam_1, this.zam_1.vac_1, this.zam_1.xac_1));
                    this.n8_1 = 1;
                    suspendResult = this.yam_1.oal_1.can(this.zam_1.vac_1.ead(), this.zam_1.wac_1, Companion_instance_8.ban(this.zam_1.vac_1, this.zam_1.xac_1), this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    noWhenBranchMatchedException();
                  }
                }
              }
            }
          }

          break;
        case 1:
          this.n8_1 = 6;
          continue $sm;
        case 2:
          this.n8_1 = 6;
          continue $sm;
        case 3:
          this.n8_1 = 6;
          continue $sm;
        case 4:
          this.n8_1 = 6;
          continue $sm;
        case 5:
          this.n8_1 = 6;
          continue $sm;
        case 6:
          return Unit_instance;
        case 7:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 7) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $waitForJoinCompletionCOROUTINE$21(_this__u8e3s4, topic, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.pak_1 = _this__u8e3s4;
  this.qak_1 = topic;
}
protoOf($waitForJoinCompletionCOROUTINE$21).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          var tmp_0 = new Long(10000, 0);
          suspendResult = withTimeoutOrNull(tmp_0, WebSocketChannelHandler$waitForJoinCompletion$slambda_0(this.pak_1, this.qak_1, null), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var tmp0_elvis_lhs = suspendResult;
          var tmp_1;
          if (tmp0_elvis_lhs == null) {
            throw Companion_instance_8.han(this.qak_1);
          } else {
            tmp_1 = tmp0_elvis_lhs;
          }

          return tmp_1;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function WebSocketChannelHandler(phoenixRefGenerator, logger) {
  Companion_getInstance_7();
  this.mal_1 = phoenixRefGenerator;
  this.nal_1 = logger;
  this.oal_1 = new ChannelStateStore();
}
protoOf(WebSocketChannelHandler).yaj = function (topic, session, $completion) {
  var tmp = new $joinCOROUTINE$19(this, topic, session, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(WebSocketChannelHandler).raj = function (event, $completion) {
  var tmp = new $handleCOROUTINE$20(this, event, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(WebSocketChannelHandler).maj = function ($completion) {
  return this.oal_1.ian(WebSocketChannelHandler$resetForNewConnection$lambda, $completion);
};
function Companion_5() {
}
protoOf(Companion_5).fan = function (topic, reason) {
  return new WebSocketChannelHandlerException('Channel join failed', topic.ead(), reason);
};
protoOf(Companion_5).han = function (topic) {
  return new WebSocketChannelHandlerException('Channel join timed out', topic.ead());
};
protoOf(Companion_5).dan = function (topic, reason) {
  return new WebSocketChannelHandlerException('Channel closed', topic.ead(), reason);
};
protoOf(Companion_5).ban = function (topic, reason) {
  return new WebSocketChannelHandlerException('Channel error', topic.ead(), reason);
};
protoOf(Companion_5).zak = function (topic) {
  return new WebSocketChannelHandlerException('Connection reset', topic.ead());
};
var Companion_instance_8;
function Companion_getInstance_8() {
  return Companion_instance_8;
}
function WebSocketChannelHandlerException(message, topic, reason) {
  topic = topic === VOID ? null : topic;
  reason = reason === VOID ? null : reason;
  Exception_init_$Init$(message, this);
  captureStack(this, WebSocketChannelHandlerException);
  this.jan_1 = topic;
  this.kan_1 = reason;
}
function WebSocketEventFactory() {
}
protoOf(WebSocketEventFactory).gak = function (from) {
  var tmp0_safe_receiver = Companion_instance_9.gak(from);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return tmp0_safe_receiver;
  }
  var tmp1_safe_receiver = Companion_instance_5.jad(from);
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return tmp1_safe_receiver;
  }
  return new Unknown(from);
};
function handleReceivedMessage($this, message) {
  var tmp;
  try {
    tmp = get_jsonArray(Default_getInstance_0().t5z(message));
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Exception) {
      var _unused_var__etf5q3 = $p;
      webSocketBreadcrumb($this.man_1, 'failed to parse message');
      return new Failure_0(MessageFailed_getInstance());
    } else {
      throw $p;
    }
  }
  var json = tmp;
  if (json.m() < 5) {
    webSocketBreadcrumb($this.man_1, 'message has insufficient elements');
    return new Failure_0(MessageFailed_getInstance());
  }
  var joinRef = parseOptionalString($this, json.o(0));
  var ref = parseOptionalString($this, json.o(1));
  var tmp_1 = json.o(2);
  var tmp0_safe_receiver = tmp_1 instanceof JsonPrimitive ? tmp_1 : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : get_contentOrNull(tmp0_safe_receiver);
  var tmp_2;
  if (tmp1_elvis_lhs == null) {
    return failMissingField($this);
  } else {
    tmp_2 = tmp1_elvis_lhs;
  }
  var topicString = tmp_2;
  var tmp_3 = json.o(3);
  var tmp2_safe_receiver = tmp_3 instanceof JsonPrimitive ? tmp_3 : null;
  var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : get_contentOrNull(tmp2_safe_receiver);
  var tmp_4;
  if (tmp3_elvis_lhs == null) {
    return failMissingField($this);
  } else {
    tmp_4 = tmp3_elvis_lhs;
  }
  var eventString = tmp_4;
  var topic = Companion_instance_6.aae(topicString);
  var event = $this.lan_1.gak(eventString);
  var payload = json.o(4);
  var tmp_5;
  if (event instanceof PhoenixEvent) {
    tmp_5 = event.nan(topic, payload, joinRef, ref);
  } else {
    if (event instanceof Event) {
      tmp_5 = event.fad(topic, payload, joinRef);
    } else {
      webSocketBreadcrumb($this.man_1, 'received unknown message type');
      return new Failure_0(MessageFailed_getInstance());
    }
  }
  var output = tmp_5;
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = output.lad_1.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    $this.man_1.i6e(Companion_instance_0.s6e(element));
  }
  return output.kad_1;
}
function failMissingField($this) {
  webSocketBreadcrumb($this.man_1, 'message missing required topic or event fields');
  return new Failure_0(MessageFailed_getInstance());
}
function parseOptionalString($this, element) {
  var tmp;
  if (element instanceof JsonNull) {
    tmp = null;
  } else {
    if (element instanceof JsonPrimitive) {
      tmp = get_contentOrNull(element);
    } else {
      tmp = null;
    }
  }
  return tmp;
}
function WebSocketMessageHandler(eventFactory, logger) {
  this.lan_1 = eventFactory;
  this.man_1 = logger;
}
protoOf(WebSocketMessageHandler).qaj = function (text) {
  return handleReceivedMessage(this, text);
};
function WebSocketMessageSender(phoenixRefGenerator, logger) {
  this.oan_1 = phoenixRefGenerator;
  this.pan_1 = logger;
}
function get_phoenixJson() {
  _init_properties_PhoenixEvent_kt__knc0ph();
  return phoenixJson;
}
var phoenixJson;
var Event_JOIN_instance;
var Event_REPLY_instance;
var Event_LEAVE_instance;
var Event_CLOSE_instance;
var Event_ERROR_instance;
function values_0() {
  return [Event_JOIN_getInstance(), Event_REPLY_getInstance(), Event_LEAVE_getInstance(), Event_CLOSE_getInstance(), Event_ERROR_getInstance()];
}
function get_entries_0() {
  if ($ENTRIES_0 == null)
    $ENTRIES_0 = enumEntries(values_0());
  return $ENTRIES_0;
}
var Event_entriesInitialized;
function Event_initEntries() {
  if (Event_entriesInitialized)
    return Unit_instance;
  Event_entriesInitialized = true;
  Event_JOIN_instance = new Event_0('JOIN', 0, 'phx_join');
  Event_REPLY_instance = new Event_0('REPLY', 1, 'phx_reply');
  Event_LEAVE_instance = new Event_0('LEAVE', 2, 'phx_leave');
  Event_CLOSE_instance = new Event_0('CLOSE', 3, 'phx_close');
  Event_ERROR_instance = new Event_0('ERROR', 4, 'phx_error');
}
var $ENTRIES_0;
function Event_0(name, ordinal, value) {
  Enum.call(this, name, ordinal);
  this.san_1 = value;
}
function Companion_6() {
}
protoOf(Companion_6).gak = function (from) {
  var tmp0 = get_entries_0();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.san_1 === from) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var event = tmp;
  var tmp_0;
  switch (event.l2_1) {
    case 0:
      tmp_0 = Join_getInstance();
      break;
    case 1:
      tmp_0 = Reply_getInstance();
      break;
    case 2:
      tmp_0 = Leave_getInstance();
      break;
    case 3:
      tmp_0 = Close_getInstance();
      break;
    case 4:
      tmp_0 = Error_getInstance();
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp_0;
};
var Companion_instance_9;
function Companion_getInstance_9() {
  return Companion_instance_9;
}
function Reply() {
  Reply_instance = this;
  PhoenixEvent.call(this);
  this.tan_1 = Event_REPLY_getInstance().san_1;
}
protoOf(Reply).ead = function () {
  return this.tan_1;
};
protoOf(Reply).nan = function (topic, payload, joinRef, ref) {
  if (topic.n1q().equals(Channel_UNKNOWN_getInstance())) {
    return new WebSocketEventHandlingOutput(new Failure_0(new MessageIgnored(MessageIgnoredReason_UNSUPPORTED_TOPIC_getInstance())));
  }
  var tmp0_elvis_lhs = payload instanceof JsonObject ? payload : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return new WebSocketEventHandlingOutput(new Failure_0(MessageFailed_getInstance()), listOf_0('\uD83E\uDDE6 WebSocket invalid payload type for phx_reply'));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var payloadObject = tmp;
  if (joinRef == null || ref == null || !(joinRef == ref)) {
    return new WebSocketEventHandlingOutput(new Failure_0(new MessageIgnored(MessageIgnoredReason_UNKNOWN_getInstance())), listOf_0('\uD83E\uDDE6 WebSocket received phx_reply for non-join push; ignoring'));
  }
  var tmp_0;
  try {
    tmp_0 = get_phoenixJson().s5z(Companion_instance_12.v61(), payloadObject);
  } catch ($p) {
    var tmp_1;
    if ($p instanceof SerializationException) {
      var _unused_var__etf5q3 = $p;
      return new WebSocketEventHandlingOutput(new Failure_0(MessageFailed_getInstance()), listOf_0('\uD83E\uDDE6 WebSocket failed to parse phx_reply payload'));
    } else {
      throw $p;
    }
  }
  var parsedPayload = tmp_0;
  var tmp_2;
  switch (parsedPayload.wan().l2_1) {
    case 0:
      tmp_2 = new WebSocketEventHandlingOutput(new Channel_0(new JoinSucceeded(topic, joinRef)), listOf_0('\uD83E\uDDE6 WebSocket successfully joined ' + topic.ead() + ' channel [' + joinRef + ']'));
      break;
    case 1:
    case 2:
      tmp_2 = new WebSocketEventHandlingOutput(new Channel_0(new JoinFailed(topic, joinRef, parsedPayload.xan())), listOf_0('\uD83E\uDDE6 WebSocket channel join to ' + topic.ead() + ' failed [' + joinRef + ']'));
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp_2;
};
protoOf(Reply).toString = function () {
  return 'Reply';
};
protoOf(Reply).hashCode = function () {
  return 1452513042;
};
protoOf(Reply).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Reply))
    return false;
  other instanceof Reply || THROW_CCE();
  return true;
};
var Reply_instance;
function Reply_getInstance() {
  if (Reply_instance == null)
    new Reply();
  return Reply_instance;
}
function Join() {
  Join_instance = this;
  PhoenixEvent.call(this);
  this.yan_1 = Event_JOIN_getInstance().san_1;
}
protoOf(Join).ead = function () {
  return this.yan_1;
};
protoOf(Join).nan = function (topic, payload, joinRef, ref) {
  return new WebSocketEventHandlingOutput(new Failure_0(new MessageIgnored(MessageIgnoredReason_UNEXPECTED_JOIN_getInstance())), listOf_0('\uD83E\uDDE6 WebSocket received unexpected phx_join event'));
};
protoOf(Join).toString = function () {
  return 'Join';
};
protoOf(Join).hashCode = function () {
  return -507563006;
};
protoOf(Join).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Join))
    return false;
  other instanceof Join || THROW_CCE();
  return true;
};
var Join_instance;
function Join_getInstance() {
  if (Join_instance == null)
    new Join();
  return Join_instance;
}
function Leave() {
  Leave_instance = this;
  PhoenixEvent.call(this);
  this.zan_1 = Event_LEAVE_getInstance().san_1;
}
protoOf(Leave).ead = function () {
  return this.zan_1;
};
protoOf(Leave).nan = function (topic, payload, joinRef, ref) {
  if (topic.n1q().equals(Channel_UNKNOWN_getInstance())) {
    return new WebSocketEventHandlingOutput(new Failure_0(new MessageIgnored(MessageIgnoredReason_UNSUPPORTED_TOPIC_getInstance())));
  }
  return new WebSocketEventHandlingOutput(new Channel_0(new Left(topic, joinRef)), listOf_0('\uD83E\uDDE6 WebSocket channel left: ' + topic.ead()));
};
protoOf(Leave).toString = function () {
  return 'Leave';
};
protoOf(Leave).hashCode = function () {
  return 1446957791;
};
protoOf(Leave).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Leave))
    return false;
  other instanceof Leave || THROW_CCE();
  return true;
};
var Leave_instance;
function Leave_getInstance() {
  if (Leave_instance == null)
    new Leave();
  return Leave_instance;
}
function Close() {
  Close_instance = this;
  PhoenixEvent.call(this);
  this.aao_1 = Event_CLOSE_getInstance().san_1;
}
protoOf(Close).ead = function () {
  return this.aao_1;
};
protoOf(Close).nan = function (topic, payload, joinRef, ref) {
  if (topic.n1q().equals(Channel_UNKNOWN_getInstance())) {
    return new WebSocketEventHandlingOutput(new Failure_0(new MessageIgnored(MessageIgnoredReason_UNSUPPORTED_TOPIC_getInstance())));
  }
  var tmp0_elvis_lhs = stringField(payload, 'reason');
  var reason = tmp0_elvis_lhs == null ? 'unknown' : tmp0_elvis_lhs;
  return new WebSocketEventHandlingOutput(new Channel_0(new Closed(topic, joinRef, reason)), listOf_0('\uD83E\uDDE6 WebSocket channel closed by server: ' + topic.ead() + ', reason: ' + reason));
};
protoOf(Close).toString = function () {
  return 'Close';
};
protoOf(Close).hashCode = function () {
  return 1438868000;
};
protoOf(Close).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Close))
    return false;
  other instanceof Close || THROW_CCE();
  return true;
};
var Close_instance;
function Close_getInstance() {
  if (Close_instance == null)
    new Close();
  return Close_instance;
}
function Error_1() {
  Error_instance = this;
  PhoenixEvent.call(this);
  this.bao_1 = Event_ERROR_getInstance().san_1;
}
protoOf(Error_1).ead = function () {
  return this.bao_1;
};
protoOf(Error_1).nan = function (topic, payload, joinRef, ref) {
  if (topic.n1q().equals(Channel_UNKNOWN_getInstance())) {
    return new WebSocketEventHandlingOutput(new Failure_0(new MessageIgnored(MessageIgnoredReason_UNSUPPORTED_TOPIC_getInstance())));
  }
  var tmp0_elvis_lhs = stringField(payload, 'reason');
  var reason = tmp0_elvis_lhs == null ? 'unknown' : tmp0_elvis_lhs;
  return new WebSocketEventHandlingOutput(new Channel_0(new Error_0(topic, joinRef, reason)), listOf_0('\uD83E\uDDE6 WebSocket channel error: ' + topic.ead() + ', reason: ' + reason));
};
protoOf(Error_1).toString = function () {
  return 'Error';
};
protoOf(Error_1).hashCode = function () {
  return 1440896560;
};
protoOf(Error_1).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Error_1))
    return false;
  other instanceof Error_1 || THROW_CCE();
  return true;
};
var Error_instance;
function Error_getInstance() {
  if (Error_instance == null)
    new Error_1();
  return Error_instance;
}
function Event_JOIN_getInstance() {
  Event_initEntries();
  return Event_JOIN_instance;
}
function Event_REPLY_getInstance() {
  Event_initEntries();
  return Event_REPLY_instance;
}
function Event_LEAVE_getInstance() {
  Event_initEntries();
  return Event_LEAVE_instance;
}
function Event_CLOSE_getInstance() {
  Event_initEntries();
  return Event_CLOSE_instance;
}
function Event_ERROR_getInstance() {
  Event_initEntries();
  return Event_ERROR_instance;
}
function PhoenixEvent() {
}
function stringField(_this__u8e3s4, key) {
  _init_properties_PhoenixEvent_kt__knc0ph();
  var tmp0_safe_receiver = _this__u8e3s4 instanceof JsonObject ? _this__u8e3s4 : null;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h2a(key);
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_0 = tmp1_safe_receiver instanceof JsonPrimitive ? tmp1_safe_receiver : null;
    tmp = tmp0_safe_receiver_0 == null ? null : get_contentOrNull(tmp0_safe_receiver_0);
  }
  return tmp;
}
function phoenixJson$lambda($this$Json) {
  _init_properties_PhoenixEvent_kt__knc0ph();
  $this$Json.k60_1 = true;
  return Unit_instance;
}
var properties_initialized_PhoenixEvent_kt_assoh9;
function _init_properties_PhoenixEvent_kt__knc0ph() {
  if (!properties_initialized_PhoenixEvent_kt_assoh9) {
    properties_initialized_PhoenixEvent_kt_assoh9 = true;
    phoenixJson = Json(VOID, phoenixJson$lambda);
  }
}
function mapToJsonObject($this, map) {
  // Inline function 'kotlinx.serialization.json.buildJsonObject' call
  var builder = new JsonObjectBuilder();
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = map.r().j();
  while (_iterator__ex2g4s.k()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.component1' call
    var key = _destruct__k2r9zo.s();
    // Inline function 'kotlin.collections.component2' call
    var value = _destruct__k2r9zo.t();
    builder.i62(key, anyToJsonElement($this, value));
  }
  return builder.a61();
}
function anyToJsonElement($this, value) {
  var tmp;
  if (value == null) {
    tmp = JsonNull_getInstance();
  } else {
    if (!(value == null) ? typeof value === 'string' : false) {
      tmp = JsonPrimitive_0(value);
    } else {
      if (isNumber(value)) {
        tmp = JsonPrimitive_2(value);
      } else {
        if (!(value == null) ? typeof value === 'boolean' : false) {
          tmp = JsonPrimitive_1(value);
        } else {
          if (!(value == null) ? isInterface(value, KtMap) : false) {
            // Inline function 'kotlinx.serialization.json.buildJsonObject' call
            var builder = new JsonObjectBuilder();
            // Inline function 'kotlin.collections.iterator' call
            var _iterator__ex2g4s = value.r().j();
            while (_iterator__ex2g4s.k()) {
              var _destruct__k2r9zo = _iterator__ex2g4s.l();
              // Inline function 'kotlin.collections.component1' call
              var key = _destruct__k2r9zo.s();
              // Inline function 'kotlin.collections.component2' call
              var nested = _destruct__k2r9zo.t();
              builder.i62(toString_0(key), anyToJsonElement($this, nested));
            }
            tmp = builder.a61();
          } else {
            if (!(value == null) ? isInterface(value, Iterable) : false) {
              // Inline function 'kotlinx.serialization.json.buildJsonArray' call
              var builder_0 = new JsonArrayBuilder();
              var _iterator__ex2g4s_0 = value.j();
              while (_iterator__ex2g4s_0.k()) {
                var item = _iterator__ex2g4s_0.l();
                builder_0.g62(anyToJsonElement($this, item));
              }
              tmp = builder_0.a61();
            } else {
              if (!(value == null) ? isArray(value) : false) {
                // Inline function 'kotlinx.serialization.json.buildJsonArray' call
                var builder_1 = new JsonArrayBuilder();
                var inductionVariable = 0;
                var last = value.length;
                while (inductionVariable < last) {
                  var item_0 = value[inductionVariable];
                  inductionVariable = inductionVariable + 1 | 0;
                  builder_1.g62(anyToJsonElement($this, item_0));
                }
                tmp = builder_1.a61();
              } else {
                tmp = JsonPrimitive_0(toString(value));
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function PhoenixOutboundMessage(joinRef, ref, topic, event, payload) {
  payload = payload === VOID ? emptyMap() : payload;
  this.rak_1 = joinRef;
  this.sak_1 = ref;
  this.tak_1 = topic;
  this.uak_1 = event;
  this.vak_1 = payload;
}
protoOf(PhoenixOutboundMessage).wak = function () {
  // Inline function 'kotlinx.serialization.json.buildJsonArray' call
  var builder = new JsonArrayBuilder();
  builder.g62(!(this.rak_1 == null) ? JsonPrimitive_0(this.rak_1) : JsonNull_getInstance());
  builder.g62(JsonPrimitive_0(this.sak_1));
  builder.g62(JsonPrimitive_0(this.tak_1.ead()));
  builder.g62(JsonPrimitive_0(this.uak_1.ead()));
  builder.g62(mapToJsonObject(this, this.vak_1));
  var jsonArray = builder.a61();
  // Inline function 'kotlinx.serialization.json.Json.encodeToString' call
  var this_0 = Default_getInstance_0();
  // Inline function 'kotlinx.serialization.serializer' call
  var this_1 = this_0.zr();
  // Inline function 'kotlinx.serialization.internal.cast' call
  var this_2 = serializer_0(this_1, createKType(getKClass(JsonArray), arrayOf([]), false));
  var tmp$ret$3 = isInterface(this_2, KSerializer) ? this_2 : THROW_CCE();
  return this_0.ap(tmp$ret$3, jsonArray);
};
function $nextRefCOROUTINE$23(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.kao_1 = _this__u8e3s4;
}
protoOf($nextRefCOROUTINE$23).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          var tmp_0 = this;
          tmp_0.lao_1 = this.kao_1.lam_1;
          this.mao_1 = this.lao_1;
          var tmp_1 = this;
          tmp_1.nao_1 = null;
          this.n8_1 = 1;
          suspendResult = this.mao_1.y27(this.nao_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          l$ret$3: do {
            var tmp$ret$0;
            l$ret$1: do {
              var tmp_2;
              try {
                var tmp_3 = this.kao_1;
                var tmp_4;
                if (this.kao_1.kam_1.equals(new Long(-1, 2147483647))) {
                  tmp_4 = new Long(0, 0);
                } else {
                  tmp_4 = this.kao_1.kam_1.r2(toLong(1));
                }
                tmp_3.kam_1 = tmp_4;
                tmp$ret$0 = this.kao_1.kam_1.toString();
                break l$ret$1;
              } catch ($p) {
                var tmp_5;
                var t = $p;
                this.mao_1.k27(this.nao_1);
                throw t;
              }
            }
             while (false);
            var tmp_6 = tmp$ret$0;
            this.mao_1.k27(this.nao_1);
            return tmp_6;
          }
           while (false);
          this.mao_1.k27(this.nao_1);
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function PhoenixRefGenerator(startAt) {
  startAt = startAt === VOID ? new Long(0, 0) : startAt;
  this.kam_1 = startAt;
  this.lam_1 = Mutex();
}
protoOf(PhoenixRefGenerator).mam = function ($completion) {
  var tmp = new $nextRefCOROUTINE$23(this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
function Companion_7() {
}
var Companion_instance_10;
function Companion_getInstance_10() {
  return Companion_instance_10;
}
function $serializer_0() {
  $serializer_instance_0 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.infrastructure.websocket.domain.services.phoenix.PhoenixReplyPayload.Response', this, 1);
  tmp0_serialDesc.wy('reason', true);
  this.oao_1 = tmp0_serialDesc;
}
protoOf($serializer_0).pao = function (encoder, value) {
  var tmp0_desc = this.oao_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  if (tmp1_output.ht(tmp0_desc, 0) ? true : !(value.qao_1 == null)) {
    tmp1_output.dt(tmp0_desc, 0, StringSerializer_getInstance(), value.qao_1);
  }
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_0).yn = function (encoder, value) {
  return this.pao(encoder, value instanceof Response ? value : THROW_CCE());
};
protoOf($serializer_0).zn = function (decoder) {
  var tmp0_desc = this.oao_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_input = decoder.kr(tmp0_desc);
  if (tmp5_input.as()) {
    tmp4_local0 = tmp5_input.yr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp5_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp5_input.yr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp5_input.lr(tmp0_desc);
  return Response_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
};
protoOf($serializer_0).xn = function () {
  return this.oao_1;
};
protoOf($serializer_0).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(StringSerializer_getInstance())];
};
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 == null)
    new $serializer_0();
  return $serializer_instance_0;
}
function Response_init_$Init$(seen0, reason, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_0().oao_1);
  }
  if (0 === (seen0 & 1))
    $this.qao_1 = null;
  else
    $this.qao_1 = reason;
  return $this;
}
function Response_init_$Create$(seen0, reason, serializationConstructorMarker) {
  return Response_init_$Init$(seen0, reason, serializationConstructorMarker, objectCreate(protoOf(Response)));
}
var Status_OK_instance;
var Status_ERROR_instance;
var Status_UNKNOWN_instance;
function Companion_8() {
}
protoOf(Companion_8).yac = function (value) {
  var tmp0 = get_entries_1();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.tao_1 === value) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$1;
  return tmp0_elvis_lhs == null ? Status_UNKNOWN_getInstance() : tmp0_elvis_lhs;
};
var Companion_instance_11;
function Companion_getInstance_11() {
  return Companion_instance_11;
}
function values_1() {
  return [Status_OK_getInstance(), Status_ERROR_getInstance(), Status_UNKNOWN_getInstance()];
}
function get_entries_1() {
  if ($ENTRIES_1 == null)
    $ENTRIES_1 = enumEntries(values_1());
  return $ENTRIES_1;
}
var Status_entriesInitialized;
function Status_initEntries() {
  if (Status_entriesInitialized)
    return Unit_instance;
  Status_entriesInitialized = true;
  Status_OK_instance = new Status('OK', 0, 'ok');
  Status_ERROR_instance = new Status('ERROR', 1, 'error');
  Status_UNKNOWN_instance = new Status('UNKNOWN', 2, 'unknown');
}
var $ENTRIES_1;
function Response(reason) {
  reason = reason === VOID ? null : reason;
  this.qao_1 = reason;
}
protoOf(Response).toString = function () {
  return 'Response(reason=' + this.qao_1 + ')';
};
protoOf(Response).hashCode = function () {
  return this.qao_1 == null ? 0 : getStringHashCode(this.qao_1);
};
protoOf(Response).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Response))
    return false;
  var tmp0_other_with_cast = other instanceof Response ? other : THROW_CCE();
  if (!(this.qao_1 == tmp0_other_with_cast.qao_1))
    return false;
  return true;
};
function Status(name, ordinal, value) {
  Enum.call(this, name, ordinal);
  this.tao_1 = value;
}
function Companion_9() {
}
protoOf(Companion_9).v61 = function () {
  return $serializer_getInstance_1();
};
var Companion_instance_12;
function Companion_getInstance_12() {
  return Companion_instance_12;
}
function $serializer_1() {
  $serializer_instance_1 = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('com.sevenshifts.shared.infrastructure.websocket.domain.services.phoenix.PhoenixReplyPayload', this, 2);
  tmp0_serialDesc.wy('status', true);
  tmp0_serialDesc.wy('response', true);
  this.uao_1 = tmp0_serialDesc;
}
protoOf($serializer_1).vao = function (encoder, value) {
  var tmp0_desc = this.uao_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  if (tmp1_output.ht(tmp0_desc, 0) ? true : !(value.uan_1 == null)) {
    tmp1_output.dt(tmp0_desc, 0, StringSerializer_getInstance(), value.uan_1);
  }
  if (tmp1_output.ht(tmp0_desc, 1) ? true : !(value.van_1 == null)) {
    tmp1_output.dt(tmp0_desc, 1, $serializer_getInstance_0(), value.van_1);
  }
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer_1).yn = function (encoder, value) {
  return this.vao(encoder, value instanceof PhoenixReplyPayload ? value : THROW_CCE());
};
protoOf($serializer_1).zn = function (decoder) {
  var tmp0_desc = this.uao_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = null;
  var tmp5_local1 = null;
  var tmp6_input = decoder.kr(tmp0_desc);
  if (tmp6_input.as()) {
    tmp4_local0 = tmp6_input.yr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp6_input.yr(tmp0_desc, 1, $serializer_getInstance_0(), tmp5_local1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp6_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp6_input.yr(tmp0_desc, 0, StringSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp6_input.yr(tmp0_desc, 1, $serializer_getInstance_0(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp6_input.lr(tmp0_desc);
  return PhoenixReplyPayload_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
};
protoOf($serializer_1).xn = function () {
  return this.uao_1;
};
protoOf($serializer_1).pz = function () {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [get_nullable(StringSerializer_getInstance()), get_nullable($serializer_getInstance_0())];
};
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 == null)
    new $serializer_1();
  return $serializer_instance_1;
}
function PhoenixReplyPayload_init_$Init$(seen0, status, response, serializationConstructorMarker, $this) {
  if (!(0 === (0 & seen0))) {
    throwMissingFieldException(seen0, 0, $serializer_getInstance_1().uao_1);
  }
  if (0 === (seen0 & 1))
    $this.uan_1 = null;
  else
    $this.uan_1 = status;
  if (0 === (seen0 & 2))
    $this.van_1 = null;
  else
    $this.van_1 = response;
  return $this;
}
function PhoenixReplyPayload_init_$Create$(seen0, status, response, serializationConstructorMarker) {
  return PhoenixReplyPayload_init_$Init$(seen0, status, response, serializationConstructorMarker, objectCreate(protoOf(PhoenixReplyPayload)));
}
function Status_OK_getInstance() {
  Status_initEntries();
  return Status_OK_instance;
}
function Status_ERROR_getInstance() {
  Status_initEntries();
  return Status_ERROR_instance;
}
function Status_UNKNOWN_getInstance() {
  Status_initEntries();
  return Status_UNKNOWN_instance;
}
function PhoenixReplyPayload(status, response) {
  status = status === VOID ? null : status;
  response = response === VOID ? null : response;
  this.uan_1 = status;
  this.van_1 = response;
}
protoOf(PhoenixReplyPayload).wan = function () {
  var tmp0_safe_receiver = this.uan_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = Companion_instance_11.yac(tmp0_safe_receiver);
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? Status_UNKNOWN_getInstance() : tmp1_elvis_lhs;
};
protoOf(PhoenixReplyPayload).xan = function () {
  var tmp0_safe_receiver = this.van_1;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qao_1;
};
protoOf(PhoenixReplyPayload).toString = function () {
  return 'PhoenixReplyPayload(status=' + this.uan_1 + ', response=' + toString_0(this.van_1) + ')';
};
protoOf(PhoenixReplyPayload).hashCode = function () {
  var result = this.uan_1 == null ? 0 : getStringHashCode(this.uan_1);
  result = imul(result, 31) + (this.van_1 == null ? 0 : this.van_1.hashCode()) | 0;
  return result;
};
protoOf(PhoenixReplyPayload).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PhoenixReplyPayload))
    return false;
  var tmp0_other_with_cast = other instanceof PhoenixReplyPayload ? other : THROW_CCE();
  if (!(this.uan_1 == tmp0_other_with_cast.uan_1))
    return false;
  if (!equals(this.van_1, tmp0_other_with_cast.van_1))
    return false;
  return true;
};
function IWebSocketPingTask() {
}
function Companion_10() {
  this.wao_1 = '[null,"0","phoenix","heartbeat",{}]';
}
var Companion_instance_13;
function Companion_getInstance_13() {
  return Companion_instance_13;
}
function WebSocketPingTask$startPinging$slambda($session, $onPingResult, this$0, resultContinuation) {
  this.fap_1 = $session;
  this.gap_1 = $onPingResult;
  this.hap_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(WebSocketPingTask$startPinging$slambda).r3m = function ($this$launch, $completion) {
  var tmp = this.s3m($this$launch, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(WebSocketPingTask$startPinging$slambda).h9 = function (p1, $completion) {
  return this.r3m((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
};
protoOf(WebSocketPingTask$startPinging$slambda).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 7;
          this.n8_1 = 1;
          continue $sm;
        case 1:
          if (!get_isActive(this.iap_1)) {
            this.n8_1 = 6;
            continue $sm;
          }

          this.o8_1 = 3;
          this.n8_1 = 2;
          suspendResult = this.fap_1.xak('[null,"0","phoenix","heartbeat",{}]', this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          this.gap_1(new Result(_Result___init__impl__xyqfz8(Unit_instance)));
          this.o8_1 = 7;
          this.n8_1 = 4;
          continue $sm;
        case 3:
          this.o8_1 = 7;
          var tmp_0 = this.q8_1;
          if (tmp_0 instanceof CancellationException) {
            this.jap_1 = this.q8_1;
            throw this.jap_1;
          } else {
            var tmp_1 = this.q8_1;
            if (tmp_1 instanceof Exception) {
              this.kap_1 = this.q8_1;
              var exception = this.kap_1;
              this.gap_1(new Result(_Result___init__impl__xyqfz8(createFailure(exception))));
              this.n8_1 = 4;
              continue $sm;
            } else {
              throw this.q8_1;
            }
          }

        case 4:
          this.o8_1 = 7;
          this.n8_1 = 5;
          suspendResult = delay(this.hap_1.lap_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 5:
          this.n8_1 = 1;
          continue $sm;
        case 6:
          return Unit_instance;
        case 7:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 7) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
protoOf(WebSocketPingTask$startPinging$slambda).s3m = function ($this$launch, completion) {
  var i = new WebSocketPingTask$startPinging$slambda(this.fap_1, this.gap_1, this.hap_1, completion);
  i.iap_1 = $this$launch;
  return i;
};
function WebSocketPingTask$startPinging$slambda_0($session, $onPingResult, this$0, resultContinuation) {
  var i = new WebSocketPingTask$startPinging$slambda($session, $onPingResult, this$0, resultContinuation);
  var l = function ($this$launch, $completion) {
    return i.r3m($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function WebSocketPingTask(pingIntervalMs) {
  pingIntervalMs = pingIntervalMs === VOID ? new Long(30000, 0) : pingIntervalMs;
  this.lap_1 = pingIntervalMs;
  this.map_1 = null;
}
protoOf(WebSocketPingTask).sah = function (scope, session, onPingResult) {
  this.kaj();
  var tmp = this;
  tmp.map_1 = launch(scope, VOID, VOID, WebSocketPingTask$startPinging$slambda_0(session, onPingResult, this, null));
};
protoOf(WebSocketPingTask).kaj = function () {
  var tmp0_safe_receiver = this.map_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.s1f();
  }
  this.map_1 = null;
};
function IReconnectionStrategy() {
}
function ExponentialBackoffReconnectionStrategy(maxAttempts, baseDelay, maxDelay) {
  maxAttempts = maxAttempts === VOID ? 25 : maxAttempts;
  baseDelay = baseDelay === VOID ? 1.0 : baseDelay;
  maxDelay = maxDelay === VOID ? 30.0 : maxDelay;
  this.nap_1 = maxAttempts;
  this.oap_1 = baseDelay;
  this.pap_1 = maxDelay;
}
protoOf(ExponentialBackoffReconnectionStrategy).saj = function (error, attemptCount) {
  return attemptCount < this.nap_1;
};
protoOf(ExponentialBackoffReconnectionStrategy).xaj = function (attemptCount) {
  // Inline function 'kotlin.math.pow' call
  var tmp$ret$0 = Math.pow(2.0, attemptCount);
  var delay = this.oap_1 * tmp$ret$0;
  // Inline function 'kotlin.math.min' call
  var b = this.pap_1;
  return Math.min(delay, b);
};
function IWebSocketSessionFactory() {
}
function KtorWebSocketSessionFactory$_init_$lambda_mp8dt0($this$httpClient) {
  $this$httpClient.k4s(Plugin_getInstance());
  return Unit_instance;
}
function KtorWebSocketSessionFactory$create$lambda($request) {
  return function ($this$webSocketSession) {
    header($this$webSocketSession, HttpHeaders_getInstance().o3z_1, $request.cae_1);
    return Unit_instance;
  };
}
function $createCOROUTINE$24(_this__u8e3s4, request, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.yap_1 = _this__u8e3s4;
  this.zap_1 = request;
}
protoOf($createCOROUTINE$24).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = webSocketSession(this.yap_1.aaq_1, this.zap_1.bae_1, KtorWebSocketSessionFactory$create$lambda(this.zap_1), this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var session = suspendResult;
          return new KtorWebSocketSession(session);
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function KtorWebSocketSessionFactory(client) {
  var tmp;
  if (client === VOID) {
    tmp = httpClient(KtorWebSocketSessionFactory$_init_$lambda_mp8dt0);
  } else {
    tmp = client;
  }
  client = tmp;
  this.aaq_1 = client;
}
protoOf(KtorWebSocketSessionFactory).oaj = function (request, $completion) {
  var tmp = new $createCOROUTINE$24(this, request, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
function KtorWebSocketSession(session) {
  this.baq_1 = session;
}
protoOf(KtorWebSocketSession).xak = function (text, $completion) {
  return send(this.baq_1, text, $completion);
};
protoOf(KtorWebSocketSession).paj = function ($completion) {
  return this.baq_1.b4e().s1w($completion);
};
protoOf(KtorWebSocketSession).laj = function ($completion) {
  return close(this.baq_1, VOID, $completion);
};
function Idle() {
  Idle_instance = this;
  ChannelJoinState.call(this);
}
protoOf(Idle).toString = function () {
  return 'Idle';
};
protoOf(Idle).hashCode = function () {
  return -2091774598;
};
protoOf(Idle).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Idle))
    return false;
  other instanceof Idle || THROW_CCE();
  return true;
};
var Idle_instance;
function Idle_getInstance() {
  if (Idle_instance == null)
    new Idle();
  return Idle_instance;
}
function Joining(joinRef, waiters) {
  var tmp;
  if (waiters === VOID) {
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp = LinkedHashMap_init_$Create$();
  } else {
    tmp = waiters;
  }
  waiters = tmp;
  ChannelJoinState.call(this);
  this.caq_1 = joinRef;
  this.daq_1 = waiters;
}
protoOf(Joining).toString = function () {
  return 'Joining(joinRef=' + this.caq_1 + ', waiters=' + toString(this.daq_1) + ')';
};
protoOf(Joining).hashCode = function () {
  var result = getStringHashCode(this.caq_1);
  result = imul(result, 31) + hashCode(this.daq_1) | 0;
  return result;
};
protoOf(Joining).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Joining))
    return false;
  var tmp0_other_with_cast = other instanceof Joining ? other : THROW_CCE();
  if (!(this.caq_1 === tmp0_other_with_cast.caq_1))
    return false;
  if (!equals(this.daq_1, tmp0_other_with_cast.daq_1))
    return false;
  return true;
};
function Joined(joinRef) {
  ChannelJoinState.call(this);
  this.eaq_1 = joinRef;
}
protoOf(Joined).toString = function () {
  return 'Joined(joinRef=' + this.eaq_1 + ')';
};
protoOf(Joined).hashCode = function () {
  return getStringHashCode(this.eaq_1);
};
protoOf(Joined).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Joined))
    return false;
  var tmp0_other_with_cast = other instanceof Joined ? other : THROW_CCE();
  if (!(this.eaq_1 === tmp0_other_with_cast.eaq_1))
    return false;
  return true;
};
function ChannelJoinState() {
}
function generateWaiterId($this) {
  var _unary__edvuaz = $this.ral_1;
  $this.ral_1 = _unary__edvuaz.w2();
  return 'waiter-' + _unary__edvuaz.toString();
}
function $beginOrAwaitJoinCOROUTINE$27(_this__u8e3s4, topicKey, candidateJoinRef, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.naq_1 = _this__u8e3s4;
  this.oaq_1 = topicKey;
  this.paq_1 = candidateJoinRef;
}
protoOf($beginOrAwaitJoinCOROUTINE$27).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          var tmp_0 = this;
          tmp_0.qaq_1 = this.naq_1.qal_1;
          this.raq_1 = this.qaq_1;
          var tmp_1 = this;
          tmp_1.saq_1 = null;
          this.n8_1 = 1;
          suspendResult = this.raq_1.y27(this.saq_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var tmp$ret$0 = Unit_instance;
          l$ret$1: do {
            var tmp_2;
            try {
              var tmp0_elvis_lhs = this.naq_1.pal_1.a2(this.oaq_1);
              var state = tmp0_elvis_lhs == null ? Idle_getInstance() : tmp0_elvis_lhs;
              var tmp_3;
              if (state instanceof Joined) {
                tmp_3 = new AwaitExisting(state.eaq_1);
              } else {
                if (state instanceof Joining) {
                  tmp_3 = new AwaitExisting(state.caq_1);
                } else {
                  if (state instanceof Idle) {
                    var tmp0 = this.naq_1.pal_1;
                    var tmp1 = this.oaq_1;
                    var value = new Joining(this.paq_1);
                    tmp0.h2(tmp1, value);
                    tmp_3 = new StartNew(this.paq_1);
                  } else {
                    noWhenBranchMatchedException();
                  }
                }
              }
              tmp$ret$0 = tmp_3;
              break l$ret$1;
            } catch ($p) {
              var tmp_4;
              var t = $p;
              this.raq_1.k27(this.saq_1);
              throw t;
            }
          }
           while (false);
          var tmp_5 = tmp$ret$0;
          this.raq_1.k27(this.saq_1);
          return tmp_5;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $waitForJoinCompletionCOROUTINE$28(_this__u8e3s4, topicKey, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.bar_1 = _this__u8e3s4;
  this.car_1 = topicKey;
}
protoOf($waitForJoinCompletionCOROUTINE$28).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 3;
          var tmp_0 = this;
          tmp_0.dar_1 = this.bar_1.qal_1;
          this.ear_1 = this.dar_1;
          var tmp_1 = this;
          tmp_1.far_1 = null;
          this.n8_1 = 1;
          suspendResult = this.ear_1.y27(this.far_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var tmp_2 = this;
          var tmp$ret$2 = Unit_instance;
          l$ret$3: do {
            var tmp$ret$0;
            l$ret$1: do {
              var tmp_3;
              try {
                var state = this.bar_1.pal_1.a2(this.car_1);
                var tmp_4;
                if (state instanceof Joined) {
                  tmp$ret$0 = state.eaq_1;
                  break l$ret$1;
                } else {
                  if (state instanceof Joining) {
                    var waiter = CompletableDeferred();
                    var id = generateWaiterId(this.bar_1);
                    state.daq_1.h2(id, waiter);
                    tmp_4 = waiter;
                  } else {
                    throw Companion_instance_14.har(this.car_1);
                  }
                }
                tmp$ret$2 = tmp_4;
                break l$ret$3;
              } catch ($p) {
                var tmp_5;
                var t = $p;
                this.ear_1.k27(this.far_1);
                throw t;
              }
            }
             while (false);
            var tmp_6 = tmp$ret$0;
            this.ear_1.k27(this.far_1);
            return tmp_6;
          }
           while (false);
          var tmp_7 = tmp$ret$2;
          this.ear_1.k27(this.far_1);
          tmp_2.gar_1 = tmp_7;
          this.n8_1 = 2;
          suspendResult = this.gar_1.e1h(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          return suspendResult;
        case 3:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 3) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $markJoinedCOROUTINE$29(_this__u8e3s4, topicKey, joinRef, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.qar_1 = _this__u8e3s4;
  this.rar_1 = topicKey;
  this.sar_1 = joinRef;
}
protoOf($markJoinedCOROUTINE$29).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          var tmp_0 = this;
          tmp_0.tar_1 = this.qar_1.qal_1;
          this.uar_1 = this.tar_1;
          var tmp_1 = this;
          tmp_1.var_1 = null;
          this.n8_1 = 1;
          suspendResult = this.uar_1.y27(this.var_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          l$ret$3: do {
            var tmp_2;
            try {
              l$ret$1: do {
                var tmp0_elvis_lhs = this.qar_1.pal_1.a2(this.rar_1);
                var tmp_3;
                if (tmp0_elvis_lhs == null) {
                  break l$ret$1;
                } else {
                  tmp_3 = tmp0_elvis_lhs;
                }
                var currentState = tmp_3;
                var tmp_4;
                if (currentState instanceof Joining) {
                  tmp_4 = currentState.caq_1 === this.sar_1;
                } else {
                  tmp_4 = false;
                }
                if (tmp_4) {
                  var tmp0 = this.qar_1.pal_1;
                  var tmp1 = this.rar_1;
                  var value = new Joined(this.sar_1);
                  tmp0.h2(tmp1, value);
                  var _iterator__ex2g4s = currentState.daq_1.c2().j();
                  while (_iterator__ex2g4s.k()) {
                    var element = _iterator__ex2g4s.l();
                    element.c1l(this.sar_1);
                  }
                } else {
                  var tmp_5;
                  if (currentState instanceof Joined) {
                    tmp_5 = currentState.eaq_1 === this.sar_1;
                  } else {
                    tmp_5 = false;
                  }
                }
              }
               while (false);
              break l$ret$3;
            } catch ($p) {
              var tmp_6;
              var t = $p;
              this.uar_1.k27(this.var_1);
              throw t;
            }
          }
           while (false);
          this.uar_1.k27(this.var_1);
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $markNotJoinedCOROUTINE$30(_this__u8e3s4, topicKey, joinRef, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.eas_1 = _this__u8e3s4;
  this.fas_1 = topicKey;
  this.gas_1 = joinRef;
}
protoOf($markNotJoinedCOROUTINE$30).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          var tmp_0 = this;
          tmp_0.has_1 = this.eas_1.qal_1;
          this.ias_1 = this.has_1;
          var tmp_1 = this;
          tmp_1.jas_1 = null;
          this.n8_1 = 1;
          suspendResult = this.ias_1.y27(this.jas_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          l$ret$3: do {
            var tmp_2;
            try {
              l$ret$1: do {
                if (this.gas_1 == null) {
                  break l$ret$1;
                }
                var tmp0_elvis_lhs = this.eas_1.pal_1.a2(this.fas_1);
                var tmp_3;
                if (tmp0_elvis_lhs == null) {
                  break l$ret$1;
                } else {
                  tmp_3 = tmp0_elvis_lhs;
                }
                var currentState = tmp_3;
                var tmp_4;
                if (currentState instanceof Joined) {
                  tmp_4 = currentState.eaq_1 === this.gas_1;
                } else {
                  tmp_4 = false;
                }
                if (tmp_4) {
                  this.eas_1.pal_1.i2(this.fas_1);
                }
              }
               while (false);
              break l$ret$3;
            } catch ($p) {
              var tmp_5;
              var t = $p;
              this.ias_1.k27(this.jas_1);
              throw t;
            }
          }
           while (false);
          this.ias_1.k27(this.jas_1);
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $failCOROUTINE$31(_this__u8e3s4, topicKey, joinRef, error, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.sas_1 = _this__u8e3s4;
  this.tas_1 = topicKey;
  this.uas_1 = joinRef;
  this.vas_1 = error;
}
protoOf($failCOROUTINE$31).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          var tmp_0 = this;
          tmp_0.was_1 = this.sas_1.qal_1;
          this.xas_1 = this.was_1;
          var tmp_1 = this;
          tmp_1.yas_1 = null;
          this.n8_1 = 1;
          suspendResult = this.xas_1.y27(this.yas_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          l$ret$3: do {
            var tmp_2;
            try {
              l$ret$1: do {
                if (this.uas_1 == null) {
                  break l$ret$1;
                }
                var currentState = this.sas_1.pal_1.a2(this.tas_1);
                var tmp_3;
                if (currentState instanceof Joining) {
                  tmp_3 = currentState.caq_1 === this.uas_1;
                } else {
                  tmp_3 = false;
                }
                if (tmp_3) {
                  this.sas_1.pal_1.i2(this.tas_1);
                  var _iterator__ex2g4s = currentState.daq_1.c2().j();
                  while (_iterator__ex2g4s.k()) {
                    var element = _iterator__ex2g4s.l();
                    element.d1l(this.vas_1);
                  }
                }
              }
               while (false);
              break l$ret$3;
            } catch ($p) {
              var tmp_4;
              var t = $p;
              this.xas_1.k27(this.yas_1);
              throw t;
            }
          }
           while (false);
          this.xas_1.k27(this.yas_1);
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $closeChannelCOROUTINE$32(_this__u8e3s4, topicKey, joinRef, error, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.hat_1 = _this__u8e3s4;
  this.iat_1 = topicKey;
  this.jat_1 = joinRef;
  this.kat_1 = error;
}
protoOf($closeChannelCOROUTINE$32).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          var tmp_0 = this;
          tmp_0.lat_1 = this.hat_1.qal_1;
          this.mat_1 = this.lat_1;
          var tmp_1 = this;
          tmp_1.nat_1 = null;
          this.n8_1 = 1;
          suspendResult = this.mat_1.y27(this.nat_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          l$ret$3: do {
            var tmp_2;
            try {
              l$ret$1: do {
                var tmp0_elvis_lhs = this.hat_1.pal_1.a2(this.iat_1);
                var tmp_3;
                if (tmp0_elvis_lhs == null) {
                  break l$ret$1;
                } else {
                  tmp_3 = tmp0_elvis_lhs;
                }
                var currentState = tmp_3;
                var tmp_4;
                if (currentState instanceof Joining) {
                  tmp_4 = currentState.caq_1;
                } else {
                  if (currentState instanceof Joined) {
                    tmp_4 = currentState.eaq_1;
                  } else {
                    if (equals(currentState, Idle_getInstance())) {
                      tmp_4 = null;
                    } else {
                      noWhenBranchMatchedException();
                    }
                  }
                }
                var activeJoinRef = tmp_4;
                if (!(this.jat_1 == null) && !(this.jat_1 == activeJoinRef)) {
                  break l$ret$1;
                }
                this.hat_1.pal_1.i2(this.iat_1);
                if (currentState instanceof Joining) {
                  var _iterator__ex2g4s = currentState.daq_1.c2().j();
                  while (_iterator__ex2g4s.k()) {
                    var element = _iterator__ex2g4s.l();
                    element.d1l(this.kat_1);
                  }
                }
              }
               while (false);
              break l$ret$3;
            } catch ($p) {
              var tmp_5;
              var t = $p;
              this.mat_1.k27(this.nat_1);
              throw t;
            }
          }
           while (false);
          this.mat_1.k27(this.nat_1);
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function $resetCOROUTINE$33(_this__u8e3s4, errorFactory, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.wat_1 = _this__u8e3s4;
  this.xat_1 = errorFactory;
}
protoOf($resetCOROUTINE$33).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          var tmp_0 = this;
          tmp_0.yat_1 = this.wat_1.qal_1;
          this.zat_1 = this.yat_1;
          var tmp_1 = this;
          tmp_1.aau_1 = null;
          this.n8_1 = 1;
          suspendResult = this.zat_1.y27(this.aau_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          l$ret$1: do {
            var tmp_2;
            try {
              var _iterator__ex2g4s = this.wat_1.pal_1.r().j();
              while (_iterator__ex2g4s.k()) {
                var _destruct__k2r9zo = _iterator__ex2g4s.l();
                var topicKey = _destruct__k2r9zo.s();
                var state = _destruct__k2r9zo.t();
                if (state instanceof Joining) {
                  var error = this.xat_1(topicKey);
                  var _iterator__ex2g4s_0 = state.daq_1.c2().j();
                  while (_iterator__ex2g4s_0.k()) {
                    var element = _iterator__ex2g4s_0.l();
                    element.d1l(error);
                  }
                }
              }
              this.wat_1.pal_1.d2();
              break l$ret$1;
            } catch ($p) {
              var tmp_3;
              var t = $p;
              this.zat_1.k27(this.aau_1);
              throw t;
            }
          }
           while (false);
          this.zat_1.k27(this.aau_1);
          return Unit_instance;
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function ChannelStateStore() {
  var tmp = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp.pal_1 = LinkedHashMap_init_$Create$();
  this.qal_1 = Mutex();
  this.ral_1 = new Long(0, 0);
}
protoOf(ChannelStateStore).nam = function (topicKey, candidateJoinRef, $completion) {
  var tmp = new $beginOrAwaitJoinCOROUTINE$27(this, topicKey, candidateJoinRef, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(ChannelStateStore).sal = function (topicKey, $completion) {
  var tmp = new $waitForJoinCompletionCOROUTINE$28(this, topicKey, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(ChannelStateStore).gan = function (topicKey, joinRef, $completion) {
  var tmp = new $markJoinedCOROUTINE$29(this, topicKey, joinRef, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(ChannelStateStore).ean = function (topicKey, joinRef, $completion) {
  var tmp = new $markNotJoinedCOROUTINE$30(this, topicKey, joinRef, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(ChannelStateStore).pam = function (topicKey, joinRef, error, $completion) {
  var tmp = new $failCOROUTINE$31(this, topicKey, joinRef, error, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(ChannelStateStore).can = function (topicKey, joinRef, error, $completion) {
  var tmp = new $closeChannelCOROUTINE$32(this, topicKey, joinRef, error, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
protoOf(ChannelStateStore).ian = function (errorFactory, $completion) {
  var tmp = new $resetCOROUTINE$33(this, errorFactory, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
function StartNew(joinRef) {
  JoinAttempt.call(this);
  this.bau_1 = joinRef;
}
protoOf(StartNew).oam = function () {
  return this.bau_1;
};
protoOf(StartNew).toString = function () {
  return 'StartNew(joinRef=' + this.bau_1 + ')';
};
protoOf(StartNew).hashCode = function () {
  return getStringHashCode(this.bau_1);
};
protoOf(StartNew).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof StartNew))
    return false;
  var tmp0_other_with_cast = other instanceof StartNew ? other : THROW_CCE();
  if (!(this.bau_1 === tmp0_other_with_cast.bau_1))
    return false;
  return true;
};
function AwaitExisting(joinRef) {
  JoinAttempt.call(this);
  this.cau_1 = joinRef;
}
protoOf(AwaitExisting).oam = function () {
  return this.cau_1;
};
protoOf(AwaitExisting).toString = function () {
  return 'AwaitExisting(joinRef=' + this.cau_1 + ')';
};
protoOf(AwaitExisting).hashCode = function () {
  return getStringHashCode(this.cau_1);
};
protoOf(AwaitExisting).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof AwaitExisting))
    return false;
  var tmp0_other_with_cast = other instanceof AwaitExisting ? other : THROW_CCE();
  if (!(this.cau_1 === tmp0_other_with_cast.cau_1))
    return false;
  return true;
};
function JoinAttempt() {
}
function Companion_11() {
}
protoOf(Companion_11).har = function (topicKey) {
  return new ChannelStateStoreException('Join not started', topicKey);
};
var Companion_instance_14;
function Companion_getInstance_14() {
  return Companion_instance_14;
}
function ChannelStateStoreException(message, topicKey) {
  topicKey = topicKey === VOID ? null : topicKey;
  Exception_init_$Init$(message, this);
  captureStack(this, ChannelStateStoreException);
  this.dau_1 = topicKey;
}
function IGetWebSocketConnectionRequestUseCase() {
}
function authProtocolHeader($this, token) {
  var encodedToken = trimEnd(Default_getInstance().ih(encodeToByteArray(token)), charArrayOf([_Char___init__impl__6a9atx(61)]));
  return 'phoenix, base64url.bearer.phx.' + encodedToken;
}
function $executeCOROUTINE$34(_this__u8e3s4, userId, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.mau_1 = _this__u8e3s4;
  this.nau_1 = userId;
}
protoOf($executeCOROUTINE$34).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 2;
          this.n8_1 = 1;
          suspendResult = this.mau_1.oau_1.eaa(this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 1:
          var tokenResult = suspendResult;
          var tmp_0;
          if (tokenResult instanceof Success) {
            tmp_0 = tokenResult.x2t_1.dae_1;
          } else {
            if (tokenResult instanceof Failure) {
              throw Companion_instance_15.qau();
            } else {
              noWhenBranchMatchedException();
            }
          }

          var token = tmp_0;
          var this_0 = URLBuilder(this.mau_1.pau_1);
          this_0.o44_1.r3q('vsn', '2.0.0');
          var url = this_0.b46();
          return new WebSocketConnectionRequest(url, authProtocolHeader(this.mau_1, token));
        case 2:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 2) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function GetWebSocketConnectionRequestUseCase(webSocketTokenAccessor, webSocketBaseUrl) {
  this.oau_1 = webSocketTokenAccessor;
  this.pau_1 = webSocketBaseUrl;
}
protoOf(GetWebSocketConnectionRequestUseCase).naj = function (userId, $completion) {
  var tmp = new $executeCOROUTINE$34(this, userId, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
};
function Companion_12() {
}
protoOf(Companion_12).qau = function () {
  return new GetWebSocketConnectionRequestUseCaseException('No WebSocket token available');
};
var Companion_instance_15;
function Companion_getInstance_15() {
  return Companion_instance_15;
}
function GetWebSocketConnectionRequestUseCaseException(message) {
  Exception_init_$Init$(message, this);
  captureStack(this, GetWebSocketConnectionRequestUseCaseException);
}
function NotificationReceived(info) {
  MessageAction.call(this);
  this.waj_1 = info;
}
protoOf(NotificationReceived).toString = function () {
  return 'NotificationReceived(info=' + this.waj_1.toString() + ')';
};
protoOf(NotificationReceived).hashCode = function () {
  return this.waj_1.hashCode();
};
protoOf(NotificationReceived).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof NotificationReceived))
    return false;
  var tmp0_other_with_cast = other instanceof NotificationReceived ? other : THROW_CCE();
  if (!this.waj_1.equals(tmp0_other_with_cast.waj_1))
    return false;
  return true;
};
function MessageAction() {
}
var NotificationEvent_UNREAD_NOTIFICATION_COUNT_UPDATED_instance;
function Companion_13() {
}
protoOf(Companion_13).iad = function (coreEvent) {
  var tmp;
  switch (coreEvent.l2_1) {
    case 0:
      tmp = NotificationEvent_UNREAD_NOTIFICATION_COUNT_UPDATED_getInstance();
      break;
    case 1:
      tmp = null;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
var Companion_instance_16;
function Companion_getInstance_16() {
  return Companion_instance_16;
}
var NotificationEvent_entriesInitialized;
function NotificationEvent_initEntries() {
  if (NotificationEvent_entriesInitialized)
    return Unit_instance;
  NotificationEvent_entriesInitialized = true;
  NotificationEvent_UNREAD_NOTIFICATION_COUNT_UPDATED_instance = new NotificationEvent('UNREAD_NOTIFICATION_COUNT_UPDATED', 0, 'unread-notification-count-updated');
}
function NotificationEvent(name, ordinal, value) {
  Enum.call(this, name, ordinal);
  this.tau_1 = value;
}
function NotificationEvent_UNREAD_NOTIFICATION_COUNT_UPDATED_getInstance() {
  NotificationEvent_initEntries();
  return NotificationEvent_UNREAD_NOTIFICATION_COUNT_UPDATED_instance;
}
function NotificationInfo(joinRef, event, payload) {
  this.taj_1 = joinRef;
  this.uaj_1 = event;
  this.vaj_1 = payload;
}
protoOf(NotificationInfo).toString = function () {
  return 'NotificationInfo(joinRef=' + this.taj_1 + ', event=' + this.uaj_1.toString() + ', payload=' + this.vaj_1.toString() + ')';
};
protoOf(NotificationInfo).hashCode = function () {
  var result = this.taj_1 == null ? 0 : getStringHashCode(this.taj_1);
  result = imul(result, 31) + this.uaj_1.hashCode() | 0;
  result = imul(result, 31) + this.vaj_1.hashCode() | 0;
  return result;
};
protoOf(NotificationInfo).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof NotificationInfo))
    return false;
  var tmp0_other_with_cast = other instanceof NotificationInfo ? other : THROW_CCE();
  if (!(this.taj_1 == tmp0_other_with_cast.taj_1))
    return false;
  if (!this.uaj_1.equals(tmp0_other_with_cast.uaj_1))
    return false;
  if (!this.vaj_1.equals(tmp0_other_with_cast.vaj_1))
    return false;
  return true;
};
function Disconnected() {
  Disconnected_instance = this;
  WebSocketConnectionState.call(this);
}
protoOf(Disconnected).toString = function () {
  return 'Disconnected';
};
protoOf(Disconnected).hashCode = function () {
  return -606725921;
};
protoOf(Disconnected).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Disconnected))
    return false;
  other instanceof Disconnected || THROW_CCE();
  return true;
};
var Disconnected_instance;
function Disconnected_getInstance() {
  if (Disconnected_instance == null)
    new Disconnected();
  return Disconnected_instance;
}
function Connecting() {
  Connecting_instance = this;
  WebSocketConnectionState.call(this);
}
protoOf(Connecting).toString = function () {
  return 'Connecting';
};
protoOf(Connecting).hashCode = function () {
  return 2022916700;
};
protoOf(Connecting).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Connecting))
    return false;
  other instanceof Connecting || THROW_CCE();
  return true;
};
var Connecting_instance;
function Connecting_getInstance() {
  if (Connecting_instance == null)
    new Connecting();
  return Connecting_instance;
}
function Connected() {
  Connected_instance = this;
  WebSocketConnectionState.call(this);
}
protoOf(Connected).toString = function () {
  return 'Connected';
};
protoOf(Connected).hashCode = function () {
  return 1035086565;
};
protoOf(Connected).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Connected))
    return false;
  other instanceof Connected || THROW_CCE();
  return true;
};
var Connected_instance;
function Connected_getInstance() {
  if (Connected_instance == null)
    new Connected();
  return Connected_instance;
}
function Reconnecting(attempt) {
  WebSocketConnectionState.call(this);
  this.uau_1 = attempt;
}
protoOf(Reconnecting).toString = function () {
  return 'Reconnecting(attempt=' + this.uau_1 + ')';
};
protoOf(Reconnecting).hashCode = function () {
  return this.uau_1;
};
protoOf(Reconnecting).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Reconnecting))
    return false;
  var tmp0_other_with_cast = other instanceof Reconnecting ? other : THROW_CCE();
  if (!(this.uau_1 === tmp0_other_with_cast.uau_1))
    return false;
  return true;
};
function Failed(reason) {
  WebSocketConnectionState.call(this);
  this.pa9_1 = reason;
}
protoOf(Failed).toString = function () {
  return 'Failed(reason=' + this.pa9_1 + ')';
};
protoOf(Failed).hashCode = function () {
  return getStringHashCode(this.pa9_1);
};
protoOf(Failed).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Failed))
    return false;
  var tmp0_other_with_cast = other instanceof Failed ? other : THROW_CCE();
  if (!(this.pa9_1 === tmp0_other_with_cast.pa9_1))
    return false;
  return true;
};
function WebSocketConnectionState() {
}
//region block: post-declaration
protoOf($serializer).qz = typeParametersSerializers;
protoOf($serializer_0).qz = typeParametersSerializers;
protoOf($serializer_1).qz = typeParametersSerializers;
//endregion
//region block: init
Companion_instance_2 = new Companion();
Companion_instance_3 = new Companion_0();
Companion_instance_4 = new Companion_1();
Companion_instance_5 = new Companion_2();
Companion_instance_6 = new Companion_3();
Companion_instance_8 = new Companion_5();
Companion_instance_9 = new Companion_6();
Companion_instance_10 = new Companion_7();
Companion_instance_11 = new Companion_8();
Companion_instance_12 = new Companion_9();
Companion_instance_13 = new Companion_10();
Companion_instance_14 = new Companion_11();
Companion_instance_15 = new Companion_12();
Companion_instance_16 = new Companion_13();
//endregion
//region block: exports
export {
  get_webSocketModule as get_webSocketModule2juokb138b51a,
  IWebSocketConnection as IWebSocketConnection1czhlczic7d9m,
  IWebSocketMessenger as IWebSocketMessenger39ixwrrlxyazo,
};
//endregion

